var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArmenianOrganizationsSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ARMAT ICONS_HOME-NON PROFITS 3",
    clipPath: "url(#clip0_5720_93417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5485 0.977403C20.7861 0.977403 20.9786 0.784837 20.9786 0.547295C20.9786 0.309753 20.7861 0.117188 20.5485 0.117188C20.311 0.117188 20.1184 0.309753 20.1184 0.547295C20.1184 0.784837 20.311 0.977403 20.5485 0.977403Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.5602 0.977403C23.7978 0.977403 23.9903 0.784837 23.9903 0.547295C23.9903 0.309753 23.7978 0.117188 23.5602 0.117188C23.3227 0.117188 23.1301 0.309753 23.1301 0.547295C23.1301 0.784837 23.3227 0.977403 23.5602 0.977403Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.4592 2.46568C11.6967 2.46568 11.8893 2.27312 11.8893 2.03558C11.8893 1.79803 11.6967 1.60547 11.4592 1.60547C11.2216 1.60547 11.0291 1.79803 11.0291 2.03558C11.0291 2.27312 11.2216 2.46568 11.4592 2.46568Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.9797 2.46568C13.2172 2.46568 13.4098 2.27312 13.4098 2.03558C13.4098 1.79803 13.2172 1.60547 12.9797 1.60547C12.7421 1.60547 12.5496 1.79803 12.5496 2.03558C12.5496 2.27312 12.7421 2.46568 12.9797 2.46568Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.9899 2.46568C16.2275 2.46568 16.42 2.27312 16.42 2.03558C16.42 1.79803 16.2275 1.60547 15.9899 1.60547C15.7524 1.60547 15.5598 1.79803 15.5598 2.03558C15.5598 2.27312 15.7524 2.46568 15.9899 2.46568Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.509 2.46568C17.7465 2.46568 17.9391 2.27312 17.9391 2.03558C17.9391 1.79803 17.7465 1.60547 17.509 1.60547C17.2714 1.60547 17.0789 1.79803 17.0789 2.03558C17.0789 2.27312 17.2714 2.46568 17.509 2.46568Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.0295 2.46568C19.267 2.46568 19.4596 2.27312 19.4596 2.03558C19.4596 1.79803 19.267 1.60547 19.0295 1.60547C18.7919 1.60547 18.5994 1.79803 18.5994 2.03558C18.5994 2.27312 18.7919 2.46568 19.0295 2.46568Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M20.5485 2.46568C20.7861 2.46568 20.9786 2.27312 20.9786 2.03558C20.9786 1.79803 20.7861 1.60547 20.5485 1.60547C20.311 1.60547 20.1184 1.79803 20.1184 2.03558C20.1184 2.27312 20.311 2.46568 20.5485 2.46568Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M22.069 2.46568C22.3066 2.46568 22.4991 2.27312 22.4991 2.03558C22.4991 1.79803 22.3066 1.60547 22.069 1.60547C21.8315 1.60547 21.6389 1.79803 21.6389 2.03558C21.6389 2.27312 21.8315 2.46568 22.069 2.46568Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M23.5602 2.46568C23.7978 2.46568 23.9903 2.27312 23.9903 2.03558C23.9903 1.79803 23.7978 1.60547 23.5602 1.60547C23.3227 1.60547 23.1301 1.79803 23.1301 2.03558C23.1301 2.27312 23.3227 2.46568 23.5602 2.46568Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M25.0793 2.46568C25.3168 2.46568 25.5094 2.27312 25.5094 2.03558C25.5094 1.79803 25.3168 1.60547 25.0793 1.60547C24.8417 1.60547 24.6492 1.79803 24.6492 2.03558C24.6492 2.27312 24.8417 2.46568 25.0793 2.46568Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M0.878594 3.98912C1.11614 3.98912 1.3087 3.79656 1.3087 3.55901C1.3087 3.32147 1.11614 3.12891 0.878594 3.12891C0.641052 3.12891 0.448486 3.32147 0.448486 3.55901C0.448486 3.79656 0.641052 3.98912 0.878594 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M2.3698 3.98912C2.60735 3.98912 2.79991 3.79656 2.79991 3.55901C2.79991 3.32147 2.60735 3.12891 2.3698 3.12891C2.13226 3.12891 1.9397 3.32147 1.9397 3.55901C1.9397 3.79656 2.13226 3.98912 2.3698 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M3.88885 3.98912C4.12639 3.98912 4.31896 3.79656 4.31896 3.55901C4.31896 3.32147 4.12639 3.12891 3.88885 3.12891C3.65131 3.12891 3.45874 3.32147 3.45874 3.55901C3.45874 3.79656 3.65131 3.98912 3.88885 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M5.40936 3.98912C5.6469 3.98912 5.83946 3.79656 5.83946 3.55901C5.83946 3.32147 5.6469 3.12891 5.40936 3.12891C5.17181 3.12891 4.97925 3.32147 4.97925 3.55901C4.97925 3.79656 5.17181 3.98912 5.40936 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M6.9284 3.98912C7.16594 3.98912 7.35851 3.79656 7.35851 3.55901C7.35851 3.32147 7.16594 3.12891 6.9284 3.12891C6.69086 3.12891 6.49829 3.32147 6.49829 3.55901C6.49829 3.79656 6.69086 3.98912 6.9284 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M8.44891 3.98912C8.68645 3.98912 8.87901 3.79656 8.87901 3.55901C8.87901 3.32147 8.68645 3.12891 8.44891 3.12891C8.21136 3.12891 8.0188 3.32147 8.0188 3.55901C8.0188 3.79656 8.21136 3.98912 8.44891 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M9.94012 3.98912C10.1777 3.98912 10.3702 3.79656 10.3702 3.55901C10.3702 3.32147 10.1777 3.12891 9.94012 3.12891C9.70258 3.12891 9.51001 3.32147 9.51001 3.55901C9.51001 3.79656 9.70258 3.98912 9.94012 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M11.4592 3.98912C11.6967 3.98912 11.8893 3.79656 11.8893 3.55901C11.8893 3.32147 11.6967 3.12891 11.4592 3.12891C11.2216 3.12891 11.0291 3.32147 11.0291 3.55901C11.0291 3.79656 11.2216 3.98912 11.4592 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M12.9797 3.98912C13.2172 3.98912 13.4098 3.79656 13.4098 3.55901C13.4098 3.32147 13.2172 3.12891 12.9797 3.12891C12.7421 3.12891 12.5496 3.32147 12.5496 3.55901C12.5496 3.79656 12.7421 3.98912 12.9797 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M14.4987 3.98912C14.7363 3.98912 14.9288 3.79656 14.9288 3.55901C14.9288 3.32147 14.7363 3.12891 14.4987 3.12891C14.2612 3.12891 14.0686 3.32147 14.0686 3.55901C14.0686 3.79656 14.2612 3.98912 14.4987 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M15.9899 3.98912C16.2275 3.98912 16.42 3.79656 16.42 3.55901C16.42 3.32147 16.2275 3.12891 15.9899 3.12891C15.7524 3.12891 15.5598 3.32147 15.5598 3.55901C15.5598 3.79656 15.7524 3.98912 15.9899 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M17.509 3.98912C17.7465 3.98912 17.9391 3.79656 17.9391 3.55901C17.9391 3.32147 17.7465 3.12891 17.509 3.12891C17.2714 3.12891 17.0789 3.32147 17.0789 3.55901C17.0789 3.79656 17.2714 3.98912 17.509 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M19.0295 3.98912C19.267 3.98912 19.4596 3.79656 19.4596 3.55901C19.4596 3.32147 19.267 3.12891 19.0295 3.12891C18.7919 3.12891 18.5994 3.32147 18.5994 3.55901C18.5994 3.79656 18.7919 3.98912 19.0295 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M20.5485 3.98912C20.7861 3.98912 20.9786 3.79656 20.9786 3.55901C20.9786 3.32147 20.7861 3.12891 20.5485 3.12891C20.311 3.12891 20.1184 3.32147 20.1184 3.55901C20.1184 3.79656 20.311 3.98912 20.5485 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M22.069 3.98912C22.3066 3.98912 22.4991 3.79656 22.4991 3.55901C22.4991 3.32147 22.3066 3.12891 22.069 3.12891C21.8315 3.12891 21.6389 3.32147 21.6389 3.55901C21.6389 3.79656 21.8315 3.98912 22.069 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M23.5602 3.98912C23.7978 3.98912 23.9903 3.79656 23.9903 3.55901C23.9903 3.32147 23.7978 3.12891 23.5602 3.12891C23.3227 3.12891 23.1301 3.32147 23.1301 3.55901C23.1301 3.79656 23.3227 3.98912 23.5602 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M25.0793 3.98912C25.3168 3.98912 25.5094 3.79656 25.5094 3.55901C25.5094 3.32147 25.3168 3.12891 25.0793 3.12891C24.8417 3.12891 24.6492 3.32147 24.6492 3.55901C24.6492 3.79656 24.8417 3.98912 25.0793 3.98912Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M0.878594 5.5067C1.11614 5.5067 1.3087 5.31413 1.3087 5.07659C1.3087 4.83905 1.11614 4.64648 0.878594 4.64648C0.641052 4.64648 0.448486 4.83905 0.448486 5.07659C0.448486 5.31413 0.641052 5.5067 0.878594 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M2.3698 5.5067C2.60735 5.5067 2.79991 5.31413 2.79991 5.07659C2.79991 4.83905 2.60735 4.64648 2.3698 4.64648C2.13226 4.64648 1.9397 4.83905 1.9397 5.07659C1.9397 5.31413 2.13226 5.5067 2.3698 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M3.88885 5.5067C4.12639 5.5067 4.31896 5.31413 4.31896 5.07659C4.31896 4.83905 4.12639 4.64648 3.88885 4.64648C3.65131 4.64648 3.45874 4.83905 3.45874 5.07659C3.45874 5.31413 3.65131 5.5067 3.88885 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M5.40936 5.5067C5.6469 5.5067 5.83946 5.31413 5.83946 5.07659C5.83946 4.83905 5.6469 4.64648 5.40936 4.64648C5.17181 4.64648 4.97925 4.83905 4.97925 5.07659C4.97925 5.31413 5.17181 5.5067 5.40936 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M6.9284 5.5067C7.16594 5.5067 7.35851 5.31413 7.35851 5.07659C7.35851 4.83905 7.16594 4.64648 6.9284 4.64648C6.69086 4.64648 6.49829 4.83905 6.49829 5.07659C6.49829 5.31413 6.69086 5.5067 6.9284 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M8.44891 5.5067C8.68645 5.5067 8.87901 5.31413 8.87901 5.07659C8.87901 4.83905 8.68645 4.64648 8.44891 4.64648C8.21136 4.64648 8.0188 4.83905 8.0188 5.07659C8.0188 5.31413 8.21136 5.5067 8.44891 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M9.94012 5.5067C10.1777 5.5067 10.3702 5.31413 10.3702 5.07659C10.3702 4.83905 10.1777 4.64648 9.94012 4.64648C9.70258 4.64648 9.51001 4.83905 9.51001 5.07659C9.51001 5.31413 9.70258 5.5067 9.94012 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M11.4592 5.5067C11.6967 5.5067 11.8893 5.31413 11.8893 5.07659C11.8893 4.83905 11.6967 4.64648 11.4592 4.64648C11.2216 4.64648 11.0291 4.83905 11.0291 5.07659C11.0291 5.31413 11.2216 5.5067 11.4592 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M12.9797 5.5067C13.2172 5.5067 13.4098 5.31413 13.4098 5.07659C13.4098 4.83905 13.2172 4.64648 12.9797 4.64648C12.7421 4.64648 12.5496 4.83905 12.5496 5.07659C12.5496 5.31413 12.7421 5.5067 12.9797 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M14.4987 5.5067C14.7363 5.5067 14.9288 5.31413 14.9288 5.07659C14.9288 4.83905 14.7363 4.64648 14.4987 4.64648C14.2612 4.64648 14.0686 4.83905 14.0686 5.07659C14.0686 5.31413 14.2612 5.5067 14.4987 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M15.9899 5.5067C16.2275 5.5067 16.42 5.31413 16.42 5.07659C16.42 4.83905 16.2275 4.64648 15.9899 4.64648C15.7524 4.64648 15.5598 4.83905 15.5598 5.07659C15.5598 5.31413 15.7524 5.5067 15.9899 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M17.509 5.5067C17.7465 5.5067 17.9391 5.31413 17.9391 5.07659C17.9391 4.83905 17.7465 4.64648 17.509 4.64648C17.2714 4.64648 17.0789 4.83905 17.0789 5.07659C17.0789 5.31413 17.2714 5.5067 17.509 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M19.0295 5.5067C19.267 5.5067 19.4596 5.31413 19.4596 5.07659C19.4596 4.83905 19.267 4.64648 19.0295 4.64648C18.7919 4.64648 18.5994 4.83905 18.5994 5.07659C18.5994 5.31413 18.7919 5.5067 19.0295 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M20.5485 5.5067C20.7861 5.5067 20.9786 5.31413 20.9786 5.07659C20.9786 4.83905 20.7861 4.64648 20.5485 4.64648C20.311 4.64648 20.1184 4.83905 20.1184 5.07659C20.1184 5.31413 20.311 5.5067 20.5485 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M22.069 5.5067C22.3066 5.5067 22.4991 5.31413 22.4991 5.07659C22.4991 4.83905 22.3066 4.64648 22.069 4.64648C21.8315 4.64648 21.6389 4.83905 21.6389 5.07659C21.6389 5.31413 21.8315 5.5067 22.069 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M23.5602 5.5067C23.7978 5.5067 23.9903 5.31413 23.9903 5.07659C23.9903 4.83905 23.7978 4.64648 23.5602 4.64648C23.3227 4.64648 23.1301 4.83905 23.1301 5.07659C23.1301 5.31413 23.3227 5.5067 23.5602 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M25.0793 5.5067C25.3168 5.5067 25.5094 5.31413 25.5094 5.07659C25.5094 4.83905 25.3168 4.64648 25.0793 4.64648C24.8417 4.64648 24.6492 4.83905 24.6492 5.07659C24.6492 5.31413 24.8417 5.5067 25.0793 5.5067Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M2.3698 7.03014C2.60735 7.03014 2.79991 6.83757 2.79991 6.60003C2.79991 6.36249 2.60735 6.16992 2.3698 6.16992C2.13226 6.16992 1.9397 6.36249 1.9397 6.60003C1.9397 6.83757 2.13226 7.03014 2.3698 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M3.88885 7.03014C4.12639 7.03014 4.31896 6.83757 4.31896 6.60003C4.31896 6.36249 4.12639 6.16992 3.88885 6.16992C3.65131 6.16992 3.45874 6.36249 3.45874 6.60003C3.45874 6.83757 3.65131 7.03014 3.88885 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M5.40936 7.03014C5.6469 7.03014 5.83946 6.83757 5.83946 6.60003C5.83946 6.36249 5.6469 6.16992 5.40936 6.16992C5.17181 6.16992 4.97925 6.36249 4.97925 6.60003C4.97925 6.83757 5.17181 7.03014 5.40936 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M6.9284 7.03014C7.16594 7.03014 7.35851 6.83757 7.35851 6.60003C7.35851 6.36249 7.16594 6.16992 6.9284 6.16992C6.69086 6.16992 6.49829 6.36249 6.49829 6.60003C6.49829 6.83757 6.69086 7.03014 6.9284 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M8.44891 7.03014C8.68645 7.03014 8.87901 6.83757 8.87901 6.60003C8.87901 6.36249 8.68645 6.16992 8.44891 6.16992C8.21136 6.16992 8.0188 6.36249 8.0188 6.60003C8.0188 6.83757 8.21136 7.03014 8.44891 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M9.94012 7.03014C10.1777 7.03014 10.3702 6.83757 10.3702 6.60003C10.3702 6.36249 10.1777 6.16992 9.94012 6.16992C9.70258 6.16992 9.51001 6.36249 9.51001 6.60003C9.51001 6.83757 9.70258 7.03014 9.94012 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M11.4592 7.03014C11.6967 7.03014 11.8893 6.83757 11.8893 6.60003C11.8893 6.36249 11.6967 6.16992 11.4592 6.16992C11.2216 6.16992 11.0291 6.36249 11.0291 6.60003C11.0291 6.83757 11.2216 7.03014 11.4592 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M12.9797 7.03014C13.2172 7.03014 13.4098 6.83757 13.4098 6.60003C13.4098 6.36249 13.2172 6.16992 12.9797 6.16992C12.7421 6.16992 12.5496 6.36249 12.5496 6.60003C12.5496 6.83757 12.7421 7.03014 12.9797 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M14.4987 7.03014C14.7363 7.03014 14.9288 6.83757 14.9288 6.60003C14.9288 6.36249 14.7363 6.16992 14.4987 6.16992C14.2612 6.16992 14.0686 6.36249 14.0686 6.60003C14.0686 6.83757 14.2612 7.03014 14.4987 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M15.9899 7.03014C16.2275 7.03014 16.42 6.83757 16.42 6.60003C16.42 6.36249 16.2275 6.16992 15.9899 6.16992C15.7524 6.16992 15.5598 6.36249 15.5598 6.60003C15.5598 6.83757 15.7524 7.03014 15.9899 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M17.509 7.03014C17.7465 7.03014 17.9391 6.83757 17.9391 6.60003C17.9391 6.36249 17.7465 6.16992 17.509 6.16992C17.2714 6.16992 17.0789 6.36249 17.0789 6.60003C17.0789 6.83757 17.2714 7.03014 17.509 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M19.0295 7.03014C19.267 7.03014 19.4596 6.83757 19.4596 6.60003C19.4596 6.36249 19.267 6.16992 19.0295 6.16992C18.7919 6.16992 18.5994 6.36249 18.5994 6.60003C18.5994 6.83757 18.7919 7.03014 19.0295 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M20.5485 7.03014C20.7861 7.03014 20.9786 6.83757 20.9786 6.60003C20.9786 6.36249 20.7861 6.16992 20.5485 6.16992C20.311 6.16992 20.1184 6.36249 20.1184 6.60003C20.1184 6.83757 20.311 7.03014 20.5485 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M22.069 7.03014C22.3066 7.03014 22.4991 6.83757 22.4991 6.60003C22.4991 6.36249 22.3066 6.16992 22.069 6.16992C21.8315 6.16992 21.6389 6.36249 21.6389 6.60003C21.6389 6.83757 21.8315 7.03014 22.069 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M23.5602 7.03014C23.7978 7.03014 23.9903 6.83757 23.9903 6.60003C23.9903 6.36249 23.7978 6.16992 23.5602 6.16992C23.3227 6.16992 23.1301 6.36249 23.1301 6.60003C23.1301 6.83757 23.3227 7.03014 23.5602 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M25.0793 7.03014C25.3168 7.03014 25.5094 6.83757 25.5094 6.60003C25.5094 6.36249 25.3168 6.16992 25.0793 6.16992C24.8417 6.16992 24.6492 6.36249 24.6492 6.60003C24.6492 6.83757 24.8417 7.03014 25.0793 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M26.5983 7.03014C26.8359 7.03014 27.0284 6.83757 27.0284 6.60003C27.0284 6.36249 26.8359 6.16992 26.5983 6.16992C26.3608 6.16992 26.1682 6.36249 26.1682 6.60003C26.1682 6.83757 26.3608 7.03014 26.5983 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M28.1188 7.03014C28.3564 7.03014 28.5489 6.83757 28.5489 6.60003C28.5489 6.36249 28.3564 6.16992 28.1188 6.16992C27.8813 6.16992 27.6887 6.36249 27.6887 6.60003C27.6887 6.83757 27.8813 7.03014 28.1188 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M29.6379 7.03014C29.8754 7.03014 30.068 6.83757 30.068 6.60003C30.068 6.36249 29.8754 6.16992 29.6379 6.16992C29.4003 6.16992 29.2078 6.36249 29.2078 6.60003C29.2078 6.83757 29.4003 7.03014 29.6379 7.03014Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M3.88885 8.54772C4.12639 8.54772 4.31896 8.35515 4.31896 8.11761C4.31896 7.88007 4.12639 7.6875 3.88885 7.6875C3.65131 7.6875 3.45874 7.88007 3.45874 8.11761C3.45874 8.35515 3.65131 8.54772 3.88885 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M5.40936 8.54772C5.6469 8.54772 5.83946 8.35515 5.83946 8.11761C5.83946 7.88007 5.6469 7.6875 5.40936 7.6875C5.17181 7.6875 4.97925 7.88007 4.97925 8.11761C4.97925 8.35515 5.17181 8.54772 5.40936 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M6.9284 8.54772C7.16594 8.54772 7.35851 8.35515 7.35851 8.11761C7.35851 7.88007 7.16594 7.6875 6.9284 7.6875C6.69086 7.6875 6.49829 7.88007 6.49829 8.11761C6.49829 8.35515 6.69086 8.54772 6.9284 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M8.44891 8.54772C8.68645 8.54772 8.87901 8.35515 8.87901 8.11761C8.87901 7.88007 8.68645 7.6875 8.44891 7.6875C8.21136 7.6875 8.0188 7.88007 8.0188 8.11761C8.0188 8.35515 8.21136 8.54772 8.44891 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M9.94012 8.54772C10.1777 8.54772 10.3702 8.35515 10.3702 8.11761C10.3702 7.88007 10.1777 7.6875 9.94012 7.6875C9.70258 7.6875 9.51001 7.88007 9.51001 8.11761C9.51001 8.35515 9.70258 8.54772 9.94012 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M11.4592 8.54772C11.6967 8.54772 11.8893 8.35515 11.8893 8.11761C11.8893 7.88007 11.6967 7.6875 11.4592 7.6875C11.2216 7.6875 11.0291 7.88007 11.0291 8.11761C11.0291 8.35515 11.2216 8.54772 11.4592 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M12.9797 8.54772C13.2172 8.54772 13.4098 8.35515 13.4098 8.11761C13.4098 7.88007 13.2172 7.6875 12.9797 7.6875C12.7421 7.6875 12.5496 7.88007 12.5496 8.11761C12.5496 8.35515 12.7421 8.54772 12.9797 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M14.4987 8.54772C14.7363 8.54772 14.9288 8.35515 14.9288 8.11761C14.9288 7.88007 14.7363 7.6875 14.4987 7.6875C14.2612 7.6875 14.0686 7.88007 14.0686 8.11761C14.0686 8.35515 14.2612 8.54772 14.4987 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M15.9899 8.54772C16.2275 8.54772 16.42 8.35515 16.42 8.11761C16.42 7.88007 16.2275 7.6875 15.9899 7.6875C15.7524 7.6875 15.5598 7.88007 15.5598 8.11761C15.5598 8.35515 15.7524 8.54772 15.9899 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M17.509 8.54772C17.7465 8.54772 17.9391 8.35515 17.9391 8.11761C17.9391 7.88007 17.7465 7.6875 17.509 7.6875C17.2714 7.6875 17.0789 7.88007 17.0789 8.11761C17.0789 8.35515 17.2714 8.54772 17.509 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M19.0295 8.54772C19.267 8.54772 19.4596 8.35515 19.4596 8.11761C19.4596 7.88007 19.267 7.6875 19.0295 7.6875C18.7919 7.6875 18.5994 7.88007 18.5994 8.11761C18.5994 8.35515 18.7919 8.54772 19.0295 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M20.5485 8.54772C20.7861 8.54772 20.9786 8.35515 20.9786 8.11761C20.9786 7.88007 20.7861 7.6875 20.5485 7.6875C20.311 7.6875 20.1184 7.88007 20.1184 8.11761C20.1184 8.35515 20.311 8.54772 20.5485 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M22.069 8.54772C22.3066 8.54772 22.4991 8.35515 22.4991 8.11761C22.4991 7.88007 22.3066 7.6875 22.069 7.6875C21.8315 7.6875 21.6389 7.88007 21.6389 8.11761C21.6389 8.35515 21.8315 8.54772 22.069 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M23.5602 8.54772C23.7978 8.54772 23.9903 8.35515 23.9903 8.11761C23.9903 7.88007 23.7978 7.6875 23.5602 7.6875C23.3227 7.6875 23.1301 7.88007 23.1301 8.11761C23.1301 8.35515 23.3227 8.54772 23.5602 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M25.0793 8.54772C25.3168 8.54772 25.5094 8.35515 25.5094 8.11761C25.5094 7.88007 25.3168 7.6875 25.0793 7.6875C24.8417 7.6875 24.6492 7.88007 24.6492 8.11761C24.6492 8.35515 24.8417 8.54772 25.0793 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M26.5983 8.54772C26.8359 8.54772 27.0284 8.35515 27.0284 8.11761C27.0284 7.88007 26.8359 7.6875 26.5983 7.6875C26.3608 7.6875 26.1682 7.88007 26.1682 8.11761C26.1682 8.35515 26.3608 8.54772 26.5983 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M28.1188 8.54772C28.3564 8.54772 28.5489 8.35515 28.5489 8.11761C28.5489 7.88007 28.3564 7.6875 28.1188 7.6875C27.8813 7.6875 27.6887 7.88007 27.6887 8.11761C27.6887 8.35515 27.8813 8.54772 28.1188 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M29.6379 8.54772C29.8754 8.54772 30.068 8.35515 30.068 8.11761C30.068 7.88007 29.8754 7.6875 29.6379 7.6875C29.4003 7.6875 29.2078 7.88007 29.2078 8.11761C29.2078 8.35515 29.4003 8.54772 29.6379 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M31.1291 8.54772C31.3666 8.54772 31.5592 8.35515 31.5592 8.11761C31.5592 7.88007 31.3666 7.6875 31.1291 7.6875C30.8915 7.6875 30.699 7.88007 30.699 8.11761C30.699 8.35515 30.8915 8.54772 31.1291 8.54772Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M3.88885 10.036C4.12639 10.036 4.31896 9.84343 4.31896 9.60589C4.31896 9.36835 4.12639 9.17578 3.88885 9.17578C3.65131 9.17578 3.45874 9.36835 3.45874 9.60589C3.45874 9.84343 3.65131 10.036 3.88885 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M5.40936 10.036C5.6469 10.036 5.83946 9.84343 5.83946 9.60589C5.83946 9.36835 5.6469 9.17578 5.40936 9.17578C5.17181 9.17578 4.97925 9.36835 4.97925 9.60589C4.97925 9.84343 5.17181 10.036 5.40936 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M6.9284 10.036C7.16594 10.036 7.35851 9.84343 7.35851 9.60589C7.35851 9.36835 7.16594 9.17578 6.9284 9.17578C6.69086 9.17578 6.49829 9.36835 6.49829 9.60589C6.49829 9.84343 6.69086 10.036 6.9284 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M8.44891 10.036C8.68645 10.036 8.87901 9.84343 8.87901 9.60589C8.87901 9.36835 8.68645 9.17578 8.44891 9.17578C8.21136 9.17578 8.0188 9.36835 8.0188 9.60589C8.0188 9.84343 8.21136 10.036 8.44891 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M9.94012 10.036C10.1777 10.036 10.3702 9.84343 10.3702 9.60589C10.3702 9.36835 10.1777 9.17578 9.94012 9.17578C9.70258 9.17578 9.51001 9.36835 9.51001 9.60589C9.51001 9.84343 9.70258 10.036 9.94012 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M11.4592 10.036C11.6967 10.036 11.8893 9.84343 11.8893 9.60589C11.8893 9.36835 11.6967 9.17578 11.4592 9.17578C11.2216 9.17578 11.0291 9.36835 11.0291 9.60589C11.0291 9.84343 11.2216 10.036 11.4592 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M12.9797 10.036C13.2172 10.036 13.4098 9.84343 13.4098 9.60589C13.4098 9.36835 13.2172 9.17578 12.9797 9.17578C12.7421 9.17578 12.5496 9.36835 12.5496 9.60589C12.5496 9.84343 12.7421 10.036 12.9797 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M14.4987 10.036C14.7363 10.036 14.9288 9.84343 14.9288 9.60589C14.9288 9.36835 14.7363 9.17578 14.4987 9.17578C14.2612 9.17578 14.0686 9.36835 14.0686 9.60589C14.0686 9.84343 14.2612 10.036 14.4987 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M15.9899 10.036C16.2275 10.036 16.42 9.84343 16.42 9.60589C16.42 9.36835 16.2275 9.17578 15.9899 9.17578C15.7524 9.17578 15.5598 9.36835 15.5598 9.60589C15.5598 9.84343 15.7524 10.036 15.9899 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M17.509 10.036C17.7465 10.036 17.9391 9.84343 17.9391 9.60589C17.9391 9.36835 17.7465 9.17578 17.509 9.17578C17.2714 9.17578 17.0789 9.36835 17.0789 9.60589C17.0789 9.84343 17.2714 10.036 17.509 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M19.0295 10.036C19.267 10.036 19.4596 9.84343 19.4596 9.60589C19.4596 9.36835 19.267 9.17578 19.0295 9.17578C18.7919 9.17578 18.5994 9.36835 18.5994 9.60589C18.5994 9.84343 18.7919 10.036 19.0295 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M20.5485 10.036C20.7861 10.036 20.9786 9.84343 20.9786 9.60589C20.9786 9.36835 20.7861 9.17578 20.5485 9.17578C20.311 9.17578 20.1184 9.36835 20.1184 9.60589C20.1184 9.84343 20.311 10.036 20.5485 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M22.069 10.036C22.3066 10.036 22.4991 9.84343 22.4991 9.60589C22.4991 9.36835 22.3066 9.17578 22.069 9.17578C21.8315 9.17578 21.6389 9.36835 21.6389 9.60589C21.6389 9.84343 21.8315 10.036 22.069 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M23.5602 10.036C23.7978 10.036 23.9903 9.84343 23.9903 9.60589C23.9903 9.36835 23.7978 9.17578 23.5602 9.17578C23.3227 9.17578 23.1301 9.36835 23.1301 9.60589C23.1301 9.84343 23.3227 10.036 23.5602 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M25.0793 10.036C25.3168 10.036 25.5094 9.84343 25.5094 9.60589C25.5094 9.36835 25.3168 9.17578 25.0793 9.17578C24.8417 9.17578 24.6492 9.36835 24.6492 9.60589C24.6492 9.84343 24.8417 10.036 25.0793 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M26.5983 10.036C26.8359 10.036 27.0284 9.84343 27.0284 9.60589C27.0284 9.36835 26.8359 9.17578 26.5983 9.17578C26.3608 9.17578 26.1682 9.36835 26.1682 9.60589C26.1682 9.84343 26.3608 10.036 26.5983 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M28.1188 10.036C28.3564 10.036 28.5489 9.84343 28.5489 9.60589C28.5489 9.36835 28.3564 9.17578 28.1188 9.17578C27.8813 9.17578 27.6887 9.36835 27.6887 9.60589C27.6887 9.84343 27.8813 10.036 28.1188 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M29.6379 10.036C29.8754 10.036 30.068 9.84343 30.068 9.60589C30.068 9.36835 29.8754 9.17578 29.6379 9.17578C29.4003 9.17578 29.2078 9.36835 29.2078 9.60589C29.2078 9.84343 29.4003 10.036 29.6379 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M31.1291 10.036C31.3666 10.036 31.5592 9.84343 31.5592 9.60589C31.5592 9.36835 31.3666 9.17578 31.1291 9.17578C30.8915 9.17578 30.699 9.36835 30.699 9.60589C30.699 9.84343 30.8915 10.036 31.1291 10.036Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M5.40936 11.5594C5.6469 11.5594 5.83946 11.3669 5.83946 11.1293C5.83946 10.8918 5.6469 10.6992 5.40936 10.6992C5.17181 10.6992 4.97925 10.8918 4.97925 11.1293C4.97925 11.3669 5.17181 11.5594 5.40936 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M6.9284 11.5594C7.16594 11.5594 7.35851 11.3669 7.35851 11.1293C7.35851 10.8918 7.16594 10.6992 6.9284 10.6992C6.69086 10.6992 6.49829 10.8918 6.49829 11.1293C6.49829 11.3669 6.69086 11.5594 6.9284 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M8.44891 11.5594C8.68645 11.5594 8.87901 11.3669 8.87901 11.1293C8.87901 10.8918 8.68645 10.6992 8.44891 10.6992C8.21136 10.6992 8.0188 10.8918 8.0188 11.1293C8.0188 11.3669 8.21136 11.5594 8.44891 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M9.94012 11.5594C10.1777 11.5594 10.3702 11.3669 10.3702 11.1293C10.3702 10.8918 10.1777 10.6992 9.94012 10.6992C9.70258 10.6992 9.51001 10.8918 9.51001 11.1293C9.51001 11.3669 9.70258 11.5594 9.94012 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M11.4592 11.5594C11.6967 11.5594 11.8893 11.3669 11.8893 11.1293C11.8893 10.8918 11.6967 10.6992 11.4592 10.6992C11.2216 10.6992 11.0291 10.8918 11.0291 11.1293C11.0291 11.3669 11.2216 11.5594 11.4592 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M12.9797 11.5594C13.2172 11.5594 13.4098 11.3669 13.4098 11.1293C13.4098 10.8918 13.2172 10.6992 12.9797 10.6992C12.7421 10.6992 12.5496 10.8918 12.5496 11.1293C12.5496 11.3669 12.7421 11.5594 12.9797 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M14.4987 11.5594C14.7363 11.5594 14.9288 11.3669 14.9288 11.1293C14.9288 10.8918 14.7363 10.6992 14.4987 10.6992C14.2612 10.6992 14.0686 10.8918 14.0686 11.1293C14.0686 11.3669 14.2612 11.5594 14.4987 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M15.9899 11.5594C16.2275 11.5594 16.42 11.3669 16.42 11.1293C16.42 10.8918 16.2275 10.6992 15.9899 10.6992C15.7524 10.6992 15.5598 10.8918 15.5598 11.1293C15.5598 11.3669 15.7524 11.5594 15.9899 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M17.509 11.5594C17.7465 11.5594 17.9391 11.3669 17.9391 11.1293C17.9391 10.8918 17.7465 10.6992 17.509 10.6992C17.2714 10.6992 17.0789 10.8918 17.0789 11.1293C17.0789 11.3669 17.2714 11.5594 17.509 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M19.0295 11.5594C19.267 11.5594 19.4596 11.3669 19.4596 11.1293C19.4596 10.8918 19.267 10.6992 19.0295 10.6992C18.7919 10.6992 18.5994 10.8918 18.5994 11.1293C18.5994 11.3669 18.7919 11.5594 19.0295 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M20.5485 11.5594C20.7861 11.5594 20.9786 11.3669 20.9786 11.1293C20.9786 10.8918 20.7861 10.6992 20.5485 10.6992C20.311 10.6992 20.1184 10.8918 20.1184 11.1293C20.1184 11.3669 20.311 11.5594 20.5485 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M22.069 11.5594C22.3066 11.5594 22.4991 11.3669 22.4991 11.1293C22.4991 10.8918 22.3066 10.6992 22.069 10.6992C21.8315 10.6992 21.6389 10.8918 21.6389 11.1293C21.6389 11.3669 21.8315 11.5594 22.069 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M23.5602 11.5594C23.7978 11.5594 23.9903 11.3669 23.9903 11.1293C23.9903 10.8918 23.7978 10.6992 23.5602 10.6992C23.3227 10.6992 23.1301 10.8918 23.1301 11.1293C23.1301 11.3669 23.3227 11.5594 23.5602 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M25.0793 11.5594C25.3168 11.5594 25.5094 11.3669 25.5094 11.1293C25.5094 10.8918 25.3168 10.6992 25.0793 10.6992C24.8417 10.6992 24.6492 10.8918 24.6492 11.1293C24.6492 11.3669 24.8417 11.5594 25.0793 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M26.5983 11.5594C26.8359 11.5594 27.0284 11.3669 27.0284 11.1293C27.0284 10.8918 26.8359 10.6992 26.5983 10.6992C26.3608 10.6992 26.1682 10.8918 26.1682 11.1293C26.1682 11.3669 26.3608 11.5594 26.5983 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M28.1188 11.5594C28.3564 11.5594 28.5489 11.3669 28.5489 11.1293C28.5489 10.8918 28.3564 10.6992 28.1188 10.6992C27.8813 10.6992 27.6887 10.8918 27.6887 11.1293C27.6887 11.3669 27.8813 11.5594 28.1188 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M29.6379 11.5594C29.8754 11.5594 30.068 11.3669 30.068 11.1293C30.068 10.8918 29.8754 10.6992 29.6379 10.6992C29.4003 10.6992 29.2078 10.8918 29.2078 11.1293C29.2078 11.3669 29.4003 11.5594 29.6379 11.5594Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M5.40936 13.077C5.6469 13.077 5.83946 12.8844 5.83946 12.6469C5.83946 12.4094 5.6469 12.2168 5.40936 12.2168C5.17181 12.2168 4.97925 12.4094 4.97925 12.6469C4.97925 12.8844 5.17181 13.077 5.40936 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M6.9284 13.077C7.16594 13.077 7.35851 12.8844 7.35851 12.6469C7.35851 12.4094 7.16594 12.2168 6.9284 12.2168C6.69086 12.2168 6.49829 12.4094 6.49829 12.6469C6.49829 12.8844 6.69086 13.077 6.9284 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M8.44891 13.077C8.68645 13.077 8.87901 12.8844 8.87901 12.6469C8.87901 12.4094 8.68645 12.2168 8.44891 12.2168C8.21136 12.2168 8.0188 12.4094 8.0188 12.6469C8.0188 12.8844 8.21136 13.077 8.44891 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M9.94012 13.077C10.1777 13.077 10.3702 12.8844 10.3702 12.6469C10.3702 12.4094 10.1777 12.2168 9.94012 12.2168C9.70258 12.2168 9.51001 12.4094 9.51001 12.6469C9.51001 12.8844 9.70258 13.077 9.94012 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M11.4592 13.077C11.6967 13.077 11.8893 12.8844 11.8893 12.6469C11.8893 12.4094 11.6967 12.2168 11.4592 12.2168C11.2216 12.2168 11.0291 12.4094 11.0291 12.6469C11.0291 12.8844 11.2216 13.077 11.4592 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M12.9797 13.077C13.2172 13.077 13.4098 12.8844 13.4098 12.6469C13.4098 12.4094 13.2172 12.2168 12.9797 12.2168C12.7421 12.2168 12.5496 12.4094 12.5496 12.6469C12.5496 12.8844 12.7421 13.077 12.9797 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M14.4987 13.077C14.7363 13.077 14.9288 12.8844 14.9288 12.6469C14.9288 12.4094 14.7363 12.2168 14.4987 12.2168C14.2612 12.2168 14.0686 12.4094 14.0686 12.6469C14.0686 12.8844 14.2612 13.077 14.4987 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M15.9899 13.077C16.2275 13.077 16.42 12.8844 16.42 12.6469C16.42 12.4094 16.2275 12.2168 15.9899 12.2168C15.7524 12.2168 15.5598 12.4094 15.5598 12.6469C15.5598 12.8844 15.7524 13.077 15.9899 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M17.509 13.077C17.7465 13.077 17.9391 12.8844 17.9391 12.6469C17.9391 12.4094 17.7465 12.2168 17.509 12.2168C17.2714 12.2168 17.0789 12.4094 17.0789 12.6469C17.0789 12.8844 17.2714 13.077 17.509 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M19.0295 13.077C19.267 13.077 19.4596 12.8844 19.4596 12.6469C19.4596 12.4094 19.267 12.2168 19.0295 12.2168C18.7919 12.2168 18.5994 12.4094 18.5994 12.6469C18.5994 12.8844 18.7919 13.077 19.0295 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M20.5485 13.077C20.7861 13.077 20.9786 12.8844 20.9786 12.6469C20.9786 12.4094 20.7861 12.2168 20.5485 12.2168C20.311 12.2168 20.1184 12.4094 20.1184 12.6469C20.1184 12.8844 20.311 13.077 20.5485 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M22.069 13.077C22.3066 13.077 22.4991 12.8844 22.4991 12.6469C22.4991 12.4094 22.3066 12.2168 22.069 12.2168C21.8315 12.2168 21.6389 12.4094 21.6389 12.6469C21.6389 12.8844 21.8315 13.077 22.069 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M23.5602 13.077C23.7978 13.077 23.9903 12.8844 23.9903 12.6469C23.9903 12.4094 23.7978 12.2168 23.5602 12.2168C23.3227 12.2168 23.1301 12.4094 23.1301 12.6469C23.1301 12.8844 23.3227 13.077 23.5602 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M25.0793 13.077C25.3168 13.077 25.5094 12.8844 25.5094 12.6469C25.5094 12.4094 25.3168 12.2168 25.0793 12.2168C24.8417 12.2168 24.6492 12.4094 24.6492 12.6469C24.6492 12.8844 24.8417 13.077 25.0793 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M26.5983 13.077C26.8359 13.077 27.0284 12.8844 27.0284 12.6469C27.0284 12.4094 26.8359 12.2168 26.5983 12.2168C26.3608 12.2168 26.1682 12.4094 26.1682 12.6469C26.1682 12.8844 26.3608 13.077 26.5983 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M28.1188 13.077C28.3564 13.077 28.5489 12.8844 28.5489 12.6469C28.5489 12.4094 28.3564 12.2168 28.1188 12.2168C27.8813 12.2168 27.6887 12.4094 27.6887 12.6469C27.6887 12.8844 27.8813 13.077 28.1188 13.077Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M3.88885 14.5946C4.12639 14.5946 4.31896 14.402 4.31896 14.1645C4.31896 13.9269 4.12639 13.7344 3.88885 13.7344C3.65131 13.7344 3.45874 13.9269 3.45874 14.1645C3.45874 14.402 3.65131 14.5946 3.88885 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M5.40936 14.5946C5.6469 14.5946 5.83946 14.402 5.83946 14.1645C5.83946 13.9269 5.6469 13.7344 5.40936 13.7344C5.17181 13.7344 4.97925 13.9269 4.97925 14.1645C4.97925 14.402 5.17181 14.5946 5.40936 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M6.9284 14.5946C7.16594 14.5946 7.35851 14.402 7.35851 14.1645C7.35851 13.9269 7.16594 13.7344 6.9284 13.7344C6.69086 13.7344 6.49829 13.9269 6.49829 14.1645C6.49829 14.402 6.69086 14.5946 6.9284 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M8.44891 14.5946C8.68645 14.5946 8.87901 14.402 8.87901 14.1645C8.87901 13.9269 8.68645 13.7344 8.44891 13.7344C8.21136 13.7344 8.0188 13.9269 8.0188 14.1645C8.0188 14.402 8.21136 14.5946 8.44891 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M9.94012 14.5946C10.1777 14.5946 10.3702 14.402 10.3702 14.1645C10.3702 13.9269 10.1777 13.7344 9.94012 13.7344C9.70258 13.7344 9.51001 13.9269 9.51001 14.1645C9.51001 14.402 9.70258 14.5946 9.94012 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M11.4592 14.5946C11.6967 14.5946 11.8893 14.402 11.8893 14.1645C11.8893 13.9269 11.6967 13.7344 11.4592 13.7344C11.2216 13.7344 11.0291 13.9269 11.0291 14.1645C11.0291 14.402 11.2216 14.5946 11.4592 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M12.9797 14.5946C13.2172 14.5946 13.4098 14.402 13.4098 14.1645C13.4098 13.9269 13.2172 13.7344 12.9797 13.7344C12.7421 13.7344 12.5496 13.9269 12.5496 14.1645C12.5496 14.402 12.7421 14.5946 12.9797 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M14.4987 14.5946C14.7363 14.5946 14.9288 14.402 14.9288 14.1645C14.9288 13.9269 14.7363 13.7344 14.4987 13.7344C14.2612 13.7344 14.0686 13.9269 14.0686 14.1645C14.0686 14.402 14.2612 14.5946 14.4987 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M15.9899 14.5946C16.2275 14.5946 16.42 14.402 16.42 14.1645C16.42 13.9269 16.2275 13.7344 15.9899 13.7344C15.7524 13.7344 15.5598 13.9269 15.5598 14.1645C15.5598 14.402 15.7524 14.5946 15.9899 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M17.509 14.5946C17.7465 14.5946 17.9391 14.402 17.9391 14.1645C17.9391 13.9269 17.7465 13.7344 17.509 13.7344C17.2714 13.7344 17.0789 13.9269 17.0789 14.1645C17.0789 14.402 17.2714 14.5946 17.509 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M19.0295 14.5946C19.267 14.5946 19.4596 14.402 19.4596 14.1645C19.4596 13.9269 19.267 13.7344 19.0295 13.7344C18.7919 13.7344 18.5994 13.9269 18.5994 14.1645C18.5994 14.402 18.7919 14.5946 19.0295 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M20.5485 14.5946C20.7861 14.5946 20.9786 14.402 20.9786 14.1645C20.9786 13.9269 20.7861 13.7344 20.5485 13.7344C20.311 13.7344 20.1184 13.9269 20.1184 14.1645C20.1184 14.402 20.311 14.5946 20.5485 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M22.069 14.5946C22.3066 14.5946 22.4991 14.402 22.4991 14.1645C22.4991 13.9269 22.3066 13.7344 22.069 13.7344C21.8315 13.7344 21.6389 13.9269 21.6389 14.1645C21.6389 14.402 21.8315 14.5946 22.069 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M23.5602 14.5946C23.7978 14.5946 23.9903 14.402 23.9903 14.1645C23.9903 13.9269 23.7978 13.7344 23.5602 13.7344C23.3227 13.7344 23.1301 13.9269 23.1301 14.1645C23.1301 14.402 23.3227 14.5946 23.5602 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M25.0793 14.5946C25.3168 14.5946 25.5094 14.402 25.5094 14.1645C25.5094 13.9269 25.3168 13.7344 25.0793 13.7344C24.8417 13.7344 24.6492 13.9269 24.6492 14.1645C24.6492 14.402 24.8417 14.5946 25.0793 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M26.5983 14.5946C26.8359 14.5946 27.0284 14.402 27.0284 14.1645C27.0284 13.9269 26.8359 13.7344 26.5983 13.7344C26.3608 13.7344 26.1682 13.9269 26.1682 14.1645C26.1682 14.402 26.3608 14.5946 26.5983 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M28.1188 14.5946C28.3564 14.5946 28.5489 14.402 28.5489 14.1645C28.5489 13.9269 28.3564 13.7344 28.1188 13.7344C27.8813 13.7344 27.6887 13.9269 27.6887 14.1645C27.6887 14.402 27.8813 14.5946 28.1188 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M29.6379 14.5946C29.8754 14.5946 30.068 14.402 30.068 14.1645C30.068 13.9269 29.8754 13.7344 29.6379 13.7344C29.4003 13.7344 29.2078 13.9269 29.2078 14.1645C29.2078 14.402 29.4003 14.5946 29.6379 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M31.1291 14.5946C31.3666 14.5946 31.5592 14.402 31.5592 14.1645C31.5592 13.9269 31.3666 13.7344 31.1291 13.7344C30.8915 13.7344 30.699 13.9269 30.699 14.1645C30.699 14.402 30.8915 14.5946 31.1291 14.5946Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M2.3698 16.118C2.60735 16.118 2.79991 15.9255 2.79991 15.6879C2.79991 15.4504 2.60735 15.2578 2.3698 15.2578C2.13226 15.2578 1.9397 15.4504 1.9397 15.6879C1.9397 15.9255 2.13226 16.118 2.3698 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M3.88885 16.118C4.12639 16.118 4.31896 15.9255 4.31896 15.6879C4.31896 15.4504 4.12639 15.2578 3.88885 15.2578C3.65131 15.2578 3.45874 15.4504 3.45874 15.6879C3.45874 15.9255 3.65131 16.118 3.88885 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M5.40936 16.118C5.6469 16.118 5.83946 15.9255 5.83946 15.6879C5.83946 15.4504 5.6469 15.2578 5.40936 15.2578C5.17181 15.2578 4.97925 15.4504 4.97925 15.6879C4.97925 15.9255 5.17181 16.118 5.40936 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M6.9284 16.118C7.16594 16.118 7.35851 15.9255 7.35851 15.6879C7.35851 15.4504 7.16594 15.2578 6.9284 15.2578C6.69086 15.2578 6.49829 15.4504 6.49829 15.6879C6.49829 15.9255 6.69086 16.118 6.9284 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M8.44891 16.118C8.68645 16.118 8.87901 15.9255 8.87901 15.6879C8.87901 15.4504 8.68645 15.2578 8.44891 15.2578C8.21136 15.2578 8.0188 15.4504 8.0188 15.6879C8.0188 15.9255 8.21136 16.118 8.44891 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M9.94012 16.118C10.1777 16.118 10.3702 15.9255 10.3702 15.6879C10.3702 15.4504 10.1777 15.2578 9.94012 15.2578C9.70258 15.2578 9.51001 15.4504 9.51001 15.6879C9.51001 15.9255 9.70258 16.118 9.94012 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M11.4592 16.118C11.6967 16.118 11.8893 15.9255 11.8893 15.6879C11.8893 15.4504 11.6967 15.2578 11.4592 15.2578C11.2216 15.2578 11.0291 15.4504 11.0291 15.6879C11.0291 15.9255 11.2216 16.118 11.4592 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M12.9797 16.118C13.2172 16.118 13.4098 15.9255 13.4098 15.6879C13.4098 15.4504 13.2172 15.2578 12.9797 15.2578C12.7421 15.2578 12.5496 15.4504 12.5496 15.6879C12.5496 15.9255 12.7421 16.118 12.9797 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M14.4987 16.118C14.7363 16.118 14.9288 15.9255 14.9288 15.6879C14.9288 15.4504 14.7363 15.2578 14.4987 15.2578C14.2612 15.2578 14.0686 15.4504 14.0686 15.6879C14.0686 15.9255 14.2612 16.118 14.4987 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M15.9899 16.118C16.2275 16.118 16.42 15.9255 16.42 15.6879C16.42 15.4504 16.2275 15.2578 15.9899 15.2578C15.7524 15.2578 15.5598 15.4504 15.5598 15.6879C15.5598 15.9255 15.7524 16.118 15.9899 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M17.509 16.118C17.7465 16.118 17.9391 15.9255 17.9391 15.6879C17.9391 15.4504 17.7465 15.2578 17.509 15.2578C17.2714 15.2578 17.0789 15.4504 17.0789 15.6879C17.0789 15.9255 17.2714 16.118 17.509 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M19.0295 16.118C19.267 16.118 19.4596 15.9255 19.4596 15.6879C19.4596 15.4504 19.267 15.2578 19.0295 15.2578C18.7919 15.2578 18.5994 15.4504 18.5994 15.6879C18.5994 15.9255 18.7919 16.118 19.0295 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M20.5485 16.118C20.7861 16.118 20.9786 15.9255 20.9786 15.6879C20.9786 15.4504 20.7861 15.2578 20.5485 15.2578C20.311 15.2578 20.1184 15.4504 20.1184 15.6879C20.1184 15.9255 20.311 16.118 20.5485 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M22.069 16.118C22.3066 16.118 22.4991 15.9255 22.4991 15.6879C22.4991 15.4504 22.3066 15.2578 22.069 15.2578C21.8315 15.2578 21.6389 15.4504 21.6389 15.6879C21.6389 15.9255 21.8315 16.118 22.069 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M23.5602 16.118C23.7978 16.118 23.9903 15.9255 23.9903 15.6879C23.9903 15.4504 23.7978 15.2578 23.5602 15.2578C23.3227 15.2578 23.1301 15.4504 23.1301 15.6879C23.1301 15.9255 23.3227 16.118 23.5602 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M25.0793 16.118C25.3168 16.118 25.5094 15.9255 25.5094 15.6879C25.5094 15.4504 25.3168 15.2578 25.0793 15.2578C24.8417 15.2578 24.6492 15.4504 24.6492 15.6879C24.6492 15.9255 24.8417 16.118 25.0793 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M26.5983 16.118C26.8359 16.118 27.0284 15.9255 27.0284 15.6879C27.0284 15.4504 26.8359 15.2578 26.5983 15.2578C26.3608 15.2578 26.1682 15.4504 26.1682 15.6879C26.1682 15.9255 26.3608 16.118 26.5983 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M28.1188 16.118C28.3564 16.118 28.5489 15.9255 28.5489 15.6879C28.5489 15.4504 28.3564 15.2578 28.1188 15.2578C27.8813 15.2578 27.6887 15.4504 27.6887 15.6879C27.6887 15.9255 27.8813 16.118 28.1188 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M29.6379 16.118C29.8754 16.118 30.068 15.9255 30.068 15.6879C30.068 15.4504 29.8754 15.2578 29.6379 15.2578C29.4003 15.2578 29.2078 15.4504 29.2078 15.6879C29.2078 15.9255 29.4003 16.118 29.6379 16.118Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M2.3698 17.6063C2.60735 17.6063 2.79991 17.4137 2.79991 17.1762C2.79991 16.9387 2.60735 16.7461 2.3698 16.7461C2.13226 16.7461 1.9397 16.9387 1.9397 17.1762C1.9397 17.4137 2.13226 17.6063 2.3698 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M3.88885 17.6063C4.12639 17.6063 4.31896 17.4137 4.31896 17.1762C4.31896 16.9387 4.12639 16.7461 3.88885 16.7461C3.65131 16.7461 3.45874 16.9387 3.45874 17.1762C3.45874 17.4137 3.65131 17.6063 3.88885 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M5.40936 17.6063C5.6469 17.6063 5.83946 17.4137 5.83946 17.1762C5.83946 16.9387 5.6469 16.7461 5.40936 16.7461C5.17181 16.7461 4.97925 16.9387 4.97925 17.1762C4.97925 17.4137 5.17181 17.6063 5.40936 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M6.9284 17.6063C7.16594 17.6063 7.35851 17.4137 7.35851 17.1762C7.35851 16.9387 7.16594 16.7461 6.9284 16.7461C6.69086 16.7461 6.49829 16.9387 6.49829 17.1762C6.49829 17.4137 6.69086 17.6063 6.9284 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M8.44891 17.6063C8.68645 17.6063 8.87901 17.4137 8.87901 17.1762C8.87901 16.9387 8.68645 16.7461 8.44891 16.7461C8.21136 16.7461 8.0188 16.9387 8.0188 17.1762C8.0188 17.4137 8.21136 17.6063 8.44891 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M9.94012 17.6063C10.1777 17.6063 10.3702 17.4137 10.3702 17.1762C10.3702 16.9387 10.1777 16.7461 9.94012 16.7461C9.70258 16.7461 9.51001 16.9387 9.51001 17.1762C9.51001 17.4137 9.70258 17.6063 9.94012 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M11.4592 17.6063C11.6967 17.6063 11.8893 17.4137 11.8893 17.1762C11.8893 16.9387 11.6967 16.7461 11.4592 16.7461C11.2216 16.7461 11.0291 16.9387 11.0291 17.1762C11.0291 17.4137 11.2216 17.6063 11.4592 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M12.9797 17.6063C13.2172 17.6063 13.4098 17.4137 13.4098 17.1762C13.4098 16.9387 13.2172 16.7461 12.9797 16.7461C12.7421 16.7461 12.5496 16.9387 12.5496 17.1762C12.5496 17.4137 12.7421 17.6063 12.9797 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M14.4987 17.6063C14.7363 17.6063 14.9288 17.4137 14.9288 17.1762C14.9288 16.9387 14.7363 16.7461 14.4987 16.7461C14.2612 16.7461 14.0686 16.9387 14.0686 17.1762C14.0686 17.4137 14.2612 17.6063 14.4987 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M15.9899 17.6063C16.2275 17.6063 16.42 17.4137 16.42 17.1762C16.42 16.9387 16.2275 16.7461 15.9899 16.7461C15.7524 16.7461 15.5598 16.9387 15.5598 17.1762C15.5598 17.4137 15.7524 17.6063 15.9899 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M17.509 17.6063C17.7465 17.6063 17.9391 17.4137 17.9391 17.1762C17.9391 16.9387 17.7465 16.7461 17.509 16.7461C17.2714 16.7461 17.0789 16.9387 17.0789 17.1762C17.0789 17.4137 17.2714 17.6063 17.509 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M19.0295 17.6063C19.267 17.6063 19.4596 17.4137 19.4596 17.1762C19.4596 16.9387 19.267 16.7461 19.0295 16.7461C18.7919 16.7461 18.5994 16.9387 18.5994 17.1762C18.5994 17.4137 18.7919 17.6063 19.0295 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M20.5485 17.6063C20.7861 17.6063 20.9786 17.4137 20.9786 17.1762C20.9786 16.9387 20.7861 16.7461 20.5485 16.7461C20.311 16.7461 20.1184 16.9387 20.1184 17.1762C20.1184 17.4137 20.311 17.6063 20.5485 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M22.069 17.6063C22.3066 17.6063 22.4991 17.4137 22.4991 17.1762C22.4991 16.9387 22.3066 16.7461 22.069 16.7461C21.8315 16.7461 21.6389 16.9387 21.6389 17.1762C21.6389 17.4137 21.8315 17.6063 22.069 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M23.5602 17.6063C23.7978 17.6063 23.9903 17.4137 23.9903 17.1762C23.9903 16.9387 23.7978 16.7461 23.5602 16.7461C23.3227 16.7461 23.1301 16.9387 23.1301 17.1762C23.1301 17.4137 23.3227 17.6063 23.5602 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M25.0793 17.6063C25.3168 17.6063 25.5094 17.4137 25.5094 17.1762C25.5094 16.9387 25.3168 16.7461 25.0793 16.7461C24.8417 16.7461 24.6492 16.9387 24.6492 17.1762C24.6492 17.4137 24.8417 17.6063 25.0793 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M26.5983 17.6063C26.8359 17.6063 27.0284 17.4137 27.0284 17.1762C27.0284 16.9387 26.8359 16.7461 26.5983 16.7461C26.3608 16.7461 26.1682 16.9387 26.1682 17.1762C26.1682 17.4137 26.3608 17.6063 26.5983 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M28.1188 17.6063C28.3564 17.6063 28.5489 17.4137 28.5489 17.1762C28.5489 16.9387 28.3564 16.7461 28.1188 16.7461C27.8813 16.7461 27.6887 16.9387 27.6887 17.1762C27.6887 17.4137 27.8813 17.6063 28.1188 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M29.6379 17.6063C29.8754 17.6063 30.068 17.4137 30.068 17.1762C30.068 16.9387 29.8754 16.7461 29.6379 16.7461C29.4003 16.7461 29.2078 16.9387 29.2078 17.1762C29.2078 17.4137 29.4003 17.6063 29.6379 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M31.1291 17.6063C31.3666 17.6063 31.5592 17.4137 31.5592 17.1762C31.5592 16.9387 31.3666 16.7461 31.1291 16.7461C30.8915 16.7461 30.699 16.9387 30.699 17.1762C30.699 17.4137 30.8915 17.6063 31.1291 17.6063Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M2.3698 19.1297C2.60735 19.1297 2.79991 18.9372 2.79991 18.6996C2.79991 18.4621 2.60735 18.2695 2.3698 18.2695C2.13226 18.2695 1.9397 18.4621 1.9397 18.6996C1.9397 18.9372 2.13226 19.1297 2.3698 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M3.88885 19.1297C4.12639 19.1297 4.31896 18.9372 4.31896 18.6996C4.31896 18.4621 4.12639 18.2695 3.88885 18.2695C3.65131 18.2695 3.45874 18.4621 3.45874 18.6996C3.45874 18.9372 3.65131 19.1297 3.88885 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M5.40936 19.1297C5.6469 19.1297 5.83946 18.9372 5.83946 18.6996C5.83946 18.4621 5.6469 18.2695 5.40936 18.2695C5.17181 18.2695 4.97925 18.4621 4.97925 18.6996C4.97925 18.9372 5.17181 19.1297 5.40936 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M6.9284 19.1297C7.16594 19.1297 7.35851 18.9372 7.35851 18.6996C7.35851 18.4621 7.16594 18.2695 6.9284 18.2695C6.69086 18.2695 6.49829 18.4621 6.49829 18.6996C6.49829 18.9372 6.69086 19.1297 6.9284 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M8.44891 19.1297C8.68645 19.1297 8.87901 18.9372 8.87901 18.6996C8.87901 18.4621 8.68645 18.2695 8.44891 18.2695C8.21136 18.2695 8.0188 18.4621 8.0188 18.6996C8.0188 18.9372 8.21136 19.1297 8.44891 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M9.94012 19.1297C10.1777 19.1297 10.3702 18.9372 10.3702 18.6996C10.3702 18.4621 10.1777 18.2695 9.94012 18.2695C9.70258 18.2695 9.51001 18.4621 9.51001 18.6996C9.51001 18.9372 9.70258 19.1297 9.94012 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M11.4592 19.1297C11.6967 19.1297 11.8893 18.9372 11.8893 18.6996C11.8893 18.4621 11.6967 18.2695 11.4592 18.2695C11.2216 18.2695 11.0291 18.4621 11.0291 18.6996C11.0291 18.9372 11.2216 19.1297 11.4592 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M12.9797 19.1297C13.2172 19.1297 13.4098 18.9372 13.4098 18.6996C13.4098 18.4621 13.2172 18.2695 12.9797 18.2695C12.7421 18.2695 12.5496 18.4621 12.5496 18.6996C12.5496 18.9372 12.7421 19.1297 12.9797 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M14.4987 19.1297C14.7363 19.1297 14.9288 18.9372 14.9288 18.6996C14.9288 18.4621 14.7363 18.2695 14.4987 18.2695C14.2612 18.2695 14.0686 18.4621 14.0686 18.6996C14.0686 18.9372 14.2612 19.1297 14.4987 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M15.9899 19.1297C16.2275 19.1297 16.42 18.9372 16.42 18.6996C16.42 18.4621 16.2275 18.2695 15.9899 18.2695C15.7524 18.2695 15.5598 18.4621 15.5598 18.6996C15.5598 18.9372 15.7524 19.1297 15.9899 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M17.509 19.1297C17.7465 19.1297 17.9391 18.9372 17.9391 18.6996C17.9391 18.4621 17.7465 18.2695 17.509 18.2695C17.2714 18.2695 17.0789 18.4621 17.0789 18.6996C17.0789 18.9372 17.2714 19.1297 17.509 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M19.0295 19.1297C19.267 19.1297 19.4596 18.9372 19.4596 18.6996C19.4596 18.4621 19.267 18.2695 19.0295 18.2695C18.7919 18.2695 18.5994 18.4621 18.5994 18.6996C18.5994 18.9372 18.7919 19.1297 19.0295 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M20.5485 19.1297C20.7861 19.1297 20.9786 18.9372 20.9786 18.6996C20.9786 18.4621 20.7861 18.2695 20.5485 18.2695C20.311 18.2695 20.1184 18.4621 20.1184 18.6996C20.1184 18.9372 20.311 19.1297 20.5485 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M22.069 19.1297C22.3066 19.1297 22.4991 18.9372 22.4991 18.6996C22.4991 18.4621 22.3066 18.2695 22.069 18.2695C21.8315 18.2695 21.6389 18.4621 21.6389 18.6996C21.6389 18.9372 21.8315 19.1297 22.069 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M23.5602 19.1297C23.7978 19.1297 23.9903 18.9372 23.9903 18.6996C23.9903 18.4621 23.7978 18.2695 23.5602 18.2695C23.3227 18.2695 23.1301 18.4621 23.1301 18.6996C23.1301 18.9372 23.3227 19.1297 23.5602 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M25.0793 19.1297C25.3168 19.1297 25.5094 18.9372 25.5094 18.6996C25.5094 18.4621 25.3168 18.2695 25.0793 18.2695C24.8417 18.2695 24.6492 18.4621 24.6492 18.6996C24.6492 18.9372 24.8417 19.1297 25.0793 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M26.5983 19.1297C26.8359 19.1297 27.0284 18.9372 27.0284 18.6996C27.0284 18.4621 26.8359 18.2695 26.5983 18.2695C26.3608 18.2695 26.1682 18.4621 26.1682 18.6996C26.1682 18.9372 26.3608 19.1297 26.5983 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M28.1188 19.1297C28.3564 19.1297 28.5489 18.9372 28.5489 18.6996C28.5489 18.4621 28.3564 18.2695 28.1188 18.2695C27.8813 18.2695 27.6887 18.4621 27.6887 18.6996C27.6887 18.9372 27.8813 19.1297 28.1188 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M29.6379 19.1297C29.8754 19.1297 30.068 18.9372 30.068 18.6996C30.068 18.4621 29.8754 18.2695 29.6379 18.2695C29.4003 18.2695 29.2078 18.4621 29.2078 18.6996C29.2078 18.9372 29.4003 19.1297 29.6379 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M31.1291 19.1297C31.3666 19.1297 31.5592 18.9372 31.5592 18.6996C31.5592 18.4621 31.3666 18.2695 31.1291 18.2695C30.8915 18.2695 30.699 18.4621 30.699 18.6996C30.699 18.9372 30.8915 19.1297 31.1291 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M32.6496 19.1297C32.8871 19.1297 33.0797 18.9372 33.0797 18.6996C33.0797 18.4621 32.8871 18.2695 32.6496 18.2695C32.412 18.2695 32.2195 18.4621 32.2195 18.6996C32.2195 18.9372 32.412 19.1297 32.6496 19.1297Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M3.88885 20.6473C4.12639 20.6473 4.31896 20.4548 4.31896 20.2172C4.31896 19.9797 4.12639 19.7871 3.88885 19.7871C3.65131 19.7871 3.45874 19.9797 3.45874 20.2172C3.45874 20.4548 3.65131 20.6473 3.88885 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M5.40936 20.6473C5.6469 20.6473 5.83946 20.4548 5.83946 20.2172C5.83946 19.9797 5.6469 19.7871 5.40936 19.7871C5.17181 19.7871 4.97925 19.9797 4.97925 20.2172C4.97925 20.4548 5.17181 20.6473 5.40936 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M6.9284 20.6473C7.16594 20.6473 7.35851 20.4548 7.35851 20.2172C7.35851 19.9797 7.16594 19.7871 6.9284 19.7871C6.69086 19.7871 6.49829 19.9797 6.49829 20.2172C6.49829 20.4548 6.69086 20.6473 6.9284 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M8.44891 20.6473C8.68645 20.6473 8.87901 20.4548 8.87901 20.2172C8.87901 19.9797 8.68645 19.7871 8.44891 19.7871C8.21136 19.7871 8.0188 19.9797 8.0188 20.2172C8.0188 20.4548 8.21136 20.6473 8.44891 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M9.94012 20.6473C10.1777 20.6473 10.3702 20.4548 10.3702 20.2172C10.3702 19.9797 10.1777 19.7871 9.94012 19.7871C9.70258 19.7871 9.51001 19.9797 9.51001 20.2172C9.51001 20.4548 9.70258 20.6473 9.94012 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M11.4592 20.6473C11.6967 20.6473 11.8893 20.4548 11.8893 20.2172C11.8893 19.9797 11.6967 19.7871 11.4592 19.7871C11.2216 19.7871 11.0291 19.9797 11.0291 20.2172C11.0291 20.4548 11.2216 20.6473 11.4592 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M12.9797 20.6473C13.2172 20.6473 13.4098 20.4548 13.4098 20.2172C13.4098 19.9797 13.2172 19.7871 12.9797 19.7871C12.7421 19.7871 12.5496 19.9797 12.5496 20.2172C12.5496 20.4548 12.7421 20.6473 12.9797 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M14.4987 20.6473C14.7363 20.6473 14.9288 20.4548 14.9288 20.2172C14.9288 19.9797 14.7363 19.7871 14.4987 19.7871C14.2612 19.7871 14.0686 19.9797 14.0686 20.2172C14.0686 20.4548 14.2612 20.6473 14.4987 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M15.9899 20.6473C16.2275 20.6473 16.42 20.4548 16.42 20.2172C16.42 19.9797 16.2275 19.7871 15.9899 19.7871C15.7524 19.7871 15.5598 19.9797 15.5598 20.2172C15.5598 20.4548 15.7524 20.6473 15.9899 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M17.509 20.6473C17.7465 20.6473 17.9391 20.4548 17.9391 20.2172C17.9391 19.9797 17.7465 19.7871 17.509 19.7871C17.2714 19.7871 17.0789 19.9797 17.0789 20.2172C17.0789 20.4548 17.2714 20.6473 17.509 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M19.0295 20.6473C19.267 20.6473 19.4596 20.4548 19.4596 20.2172C19.4596 19.9797 19.267 19.7871 19.0295 19.7871C18.7919 19.7871 18.5994 19.9797 18.5994 20.2172C18.5994 20.4548 18.7919 20.6473 19.0295 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M20.5485 20.6473C20.7861 20.6473 20.9786 20.4548 20.9786 20.2172C20.9786 19.9797 20.7861 19.7871 20.5485 19.7871C20.311 19.7871 20.1184 19.9797 20.1184 20.2172C20.1184 20.4548 20.311 20.6473 20.5485 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M22.069 20.6473C22.3066 20.6473 22.4991 20.4548 22.4991 20.2172C22.4991 19.9797 22.3066 19.7871 22.069 19.7871C21.8315 19.7871 21.6389 19.9797 21.6389 20.2172C21.6389 20.4548 21.8315 20.6473 22.069 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M23.5602 20.6473C23.7978 20.6473 23.9903 20.4548 23.9903 20.2172C23.9903 19.9797 23.7978 19.7871 23.5602 19.7871C23.3227 19.7871 23.1301 19.9797 23.1301 20.2172C23.1301 20.4548 23.3227 20.6473 23.5602 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M25.0793 20.6473C25.3168 20.6473 25.5094 20.4548 25.5094 20.2172C25.5094 19.9797 25.3168 19.7871 25.0793 19.7871C24.8417 19.7871 24.6492 19.9797 24.6492 20.2172C24.6492 20.4548 24.8417 20.6473 25.0793 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M26.5983 20.6473C26.8359 20.6473 27.0284 20.4548 27.0284 20.2172C27.0284 19.9797 26.8359 19.7871 26.5983 19.7871C26.3608 19.7871 26.1682 19.9797 26.1682 20.2172C26.1682 20.4548 26.3608 20.6473 26.5983 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M28.1188 20.6473C28.3564 20.6473 28.5489 20.4548 28.5489 20.2172C28.5489 19.9797 28.3564 19.7871 28.1188 19.7871C27.8813 19.7871 27.6887 19.9797 27.6887 20.2172C27.6887 20.4548 27.8813 20.6473 28.1188 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M29.6379 20.6473C29.8754 20.6473 30.068 20.4548 30.068 20.2172C30.068 19.9797 29.8754 19.7871 29.6379 19.7871C29.4003 19.7871 29.2078 19.9797 29.2078 20.2172C29.2078 20.4548 29.4003 20.6473 29.6379 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M31.1291 20.6473C31.3666 20.6473 31.5592 20.4548 31.5592 20.2172C31.5592 19.9797 31.3666 19.7871 31.1291 19.7871C30.8915 19.7871 30.699 19.9797 30.699 20.2172C30.699 20.4548 30.8915 20.6473 31.1291 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M32.6496 20.6473C32.8871 20.6473 33.0797 20.4548 33.0797 20.2172C33.0797 19.9797 32.8871 19.7871 32.6496 19.7871C32.412 19.7871 32.2195 19.9797 32.2195 20.2172C32.2195 20.4548 32.412 20.6473 32.6496 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M34.1686 20.6473C34.4062 20.6473 34.5987 20.4548 34.5987 20.2172C34.5987 19.9797 34.4062 19.7871 34.1686 19.7871C33.9311 19.7871 33.7385 19.9797 33.7385 20.2172C33.7385 20.4548 33.9311 20.6473 34.1686 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M35.6891 20.6473C35.9267 20.6473 36.1192 20.4548 36.1192 20.2172C36.1192 19.9797 35.9267 19.7871 35.6891 19.7871C35.4516 19.7871 35.259 19.9797 35.259 20.2172C35.259 20.4548 35.4516 20.6473 35.6891 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M37.1804 20.6473C37.4179 20.6473 37.6105 20.4548 37.6105 20.2172C37.6105 19.9797 37.4179 19.7871 37.1804 19.7871C36.9428 19.7871 36.7502 19.9797 36.7502 20.2172C36.7502 20.4548 36.9428 20.6473 37.1804 20.6473Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M3.88885 22.1649C4.12639 22.1649 4.31896 21.9723 4.31896 21.7348C4.31896 21.4973 4.12639 21.3047 3.88885 21.3047C3.65131 21.3047 3.45874 21.4973 3.45874 21.7348C3.45874 21.9723 3.65131 22.1649 3.88885 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M5.40936 22.1649C5.6469 22.1649 5.83946 21.9723 5.83946 21.7348C5.83946 21.4973 5.6469 21.3047 5.40936 21.3047C5.17181 21.3047 4.97925 21.4973 4.97925 21.7348C4.97925 21.9723 5.17181 22.1649 5.40936 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M6.9284 22.1649C7.16594 22.1649 7.35851 21.9723 7.35851 21.7348C7.35851 21.4973 7.16594 21.3047 6.9284 21.3047C6.69086 21.3047 6.49829 21.4973 6.49829 21.7348C6.49829 21.9723 6.69086 22.1649 6.9284 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M8.44891 22.1649C8.68645 22.1649 8.87901 21.9723 8.87901 21.7348C8.87901 21.4973 8.68645 21.3047 8.44891 21.3047C8.21136 21.3047 8.0188 21.4973 8.0188 21.7348C8.0188 21.9723 8.21136 22.1649 8.44891 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M9.94012 22.1649C10.1777 22.1649 10.3702 21.9723 10.3702 21.7348C10.3702 21.4973 10.1777 21.3047 9.94012 21.3047C9.70258 21.3047 9.51001 21.4973 9.51001 21.7348C9.51001 21.9723 9.70258 22.1649 9.94012 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M11.4592 22.1649C11.6967 22.1649 11.8893 21.9723 11.8893 21.7348C11.8893 21.4973 11.6967 21.3047 11.4592 21.3047C11.2216 21.3047 11.0291 21.4973 11.0291 21.7348C11.0291 21.9723 11.2216 22.1649 11.4592 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M12.9797 22.1649C13.2172 22.1649 13.4098 21.9723 13.4098 21.7348C13.4098 21.4973 13.2172 21.3047 12.9797 21.3047C12.7421 21.3047 12.5496 21.4973 12.5496 21.7348C12.5496 21.9723 12.7421 22.1649 12.9797 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M14.4987 22.1649C14.7363 22.1649 14.9288 21.9723 14.9288 21.7348C14.9288 21.4973 14.7363 21.3047 14.4987 21.3047C14.2612 21.3047 14.0686 21.4973 14.0686 21.7348C14.0686 21.9723 14.2612 22.1649 14.4987 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M15.9899 22.1649C16.2275 22.1649 16.42 21.9723 16.42 21.7348C16.42 21.4973 16.2275 21.3047 15.9899 21.3047C15.7524 21.3047 15.5598 21.4973 15.5598 21.7348C15.5598 21.9723 15.7524 22.1649 15.9899 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M17.509 22.1649C17.7465 22.1649 17.9391 21.9723 17.9391 21.7348C17.9391 21.4973 17.7465 21.3047 17.509 21.3047C17.2714 21.3047 17.0789 21.4973 17.0789 21.7348C17.0789 21.9723 17.2714 22.1649 17.509 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M19.0295 22.1649C19.267 22.1649 19.4596 21.9723 19.4596 21.7348C19.4596 21.4973 19.267 21.3047 19.0295 21.3047C18.7919 21.3047 18.5994 21.4973 18.5994 21.7348C18.5994 21.9723 18.7919 22.1649 19.0295 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M20.5485 22.1649C20.7861 22.1649 20.9786 21.9723 20.9786 21.7348C20.9786 21.4973 20.7861 21.3047 20.5485 21.3047C20.311 21.3047 20.1184 21.4973 20.1184 21.7348C20.1184 21.9723 20.311 22.1649 20.5485 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M22.069 22.1649C22.3066 22.1649 22.4991 21.9723 22.4991 21.7348C22.4991 21.4973 22.3066 21.3047 22.069 21.3047C21.8315 21.3047 21.6389 21.4973 21.6389 21.7348C21.6389 21.9723 21.8315 22.1649 22.069 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M23.5602 22.1649C23.7978 22.1649 23.9903 21.9723 23.9903 21.7348C23.9903 21.4973 23.7978 21.3047 23.5602 21.3047C23.3227 21.3047 23.1301 21.4973 23.1301 21.7348C23.1301 21.9723 23.3227 22.1649 23.5602 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M25.0793 22.1649C25.3168 22.1649 25.5094 21.9723 25.5094 21.7348C25.5094 21.4973 25.3168 21.3047 25.0793 21.3047C24.8417 21.3047 24.6492 21.4973 24.6492 21.7348C24.6492 21.9723 24.8417 22.1649 25.0793 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M26.5983 22.1649C26.8359 22.1649 27.0284 21.9723 27.0284 21.7348C27.0284 21.4973 26.8359 21.3047 26.5983 21.3047C26.3608 21.3047 26.1682 21.4973 26.1682 21.7348C26.1682 21.9723 26.3608 22.1649 26.5983 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M28.1188 22.1649C28.3564 22.1649 28.5489 21.9723 28.5489 21.7348C28.5489 21.4973 28.3564 21.3047 28.1188 21.3047C27.8813 21.3047 27.6887 21.4973 27.6887 21.7348C27.6887 21.9723 27.8813 22.1649 28.1188 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M29.6379 22.1649C29.8754 22.1649 30.068 21.9723 30.068 21.7348C30.068 21.4973 29.8754 21.3047 29.6379 21.3047C29.4003 21.3047 29.2078 21.4973 29.2078 21.7348C29.2078 21.9723 29.4003 22.1649 29.6379 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M31.1291 22.1649C31.3666 22.1649 31.5592 21.9723 31.5592 21.7348C31.5592 21.4973 31.3666 21.3047 31.1291 21.3047C30.8915 21.3047 30.699 21.4973 30.699 21.7348C30.699 21.9723 30.8915 22.1649 31.1291 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M32.6496 22.1649C32.8871 22.1649 33.0797 21.9723 33.0797 21.7348C33.0797 21.4973 32.8871 21.3047 32.6496 21.3047C32.412 21.3047 32.2195 21.4973 32.2195 21.7348C32.2195 21.9723 32.412 22.1649 32.6496 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M34.1686 22.1649C34.4062 22.1649 34.5987 21.9723 34.5987 21.7348C34.5987 21.4973 34.4062 21.3047 34.1686 21.3047C33.9311 21.3047 33.7385 21.4973 33.7385 21.7348C33.7385 21.9723 33.9311 22.1649 34.1686 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M35.6891 22.1649C35.9267 22.1649 36.1192 21.9723 36.1192 21.7348C36.1192 21.4973 35.9267 21.3047 35.6891 21.3047C35.4516 21.3047 35.259 21.4973 35.259 21.7348C35.259 21.9723 35.4516 22.1649 35.6891 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M37.1804 22.1649C37.4179 22.1649 37.6105 21.9723 37.6105 21.7348C37.6105 21.4973 37.4179 21.3047 37.1804 21.3047C36.9428 21.3047 36.7502 21.4973 36.7502 21.7348C36.7502 21.9723 36.9428 22.1649 37.1804 22.1649Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M3.88885 23.659C4.12639 23.659 4.31896 23.4665 4.31896 23.2289C4.31896 22.9914 4.12639 22.7988 3.88885 22.7988C3.65131 22.7988 3.45874 22.9914 3.45874 23.2289C3.45874 23.4665 3.65131 23.659 3.88885 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M5.40936 23.659C5.6469 23.659 5.83946 23.4665 5.83946 23.2289C5.83946 22.9914 5.6469 22.7988 5.40936 22.7988C5.17181 22.7988 4.97925 22.9914 4.97925 23.2289C4.97925 23.4665 5.17181 23.659 5.40936 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M6.9284 23.659C7.16594 23.659 7.35851 23.4665 7.35851 23.2289C7.35851 22.9914 7.16594 22.7988 6.9284 22.7988C6.69086 22.7988 6.49829 22.9914 6.49829 23.2289C6.49829 23.4665 6.69086 23.659 6.9284 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M8.44891 23.659C8.68645 23.659 8.87901 23.4665 8.87901 23.2289C8.87901 22.9914 8.68645 22.7988 8.44891 22.7988C8.21136 22.7988 8.0188 22.9914 8.0188 23.2289C8.0188 23.4665 8.21136 23.659 8.44891 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M9.94012 23.659C10.1777 23.659 10.3702 23.4665 10.3702 23.2289C10.3702 22.9914 10.1777 22.7988 9.94012 22.7988C9.70258 22.7988 9.51001 22.9914 9.51001 23.2289C9.51001 23.4665 9.70258 23.659 9.94012 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M11.4592 23.659C11.6967 23.659 11.8893 23.4665 11.8893 23.2289C11.8893 22.9914 11.6967 22.7988 11.4592 22.7988C11.2216 22.7988 11.0291 22.9914 11.0291 23.2289C11.0291 23.4665 11.2216 23.659 11.4592 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M12.9797 23.659C13.2172 23.659 13.4098 23.4665 13.4098 23.2289C13.4098 22.9914 13.2172 22.7988 12.9797 22.7988C12.7421 22.7988 12.5496 22.9914 12.5496 23.2289C12.5496 23.4665 12.7421 23.659 12.9797 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M14.4987 23.659C14.7363 23.659 14.9288 23.4665 14.9288 23.2289C14.9288 22.9914 14.7363 22.7988 14.4987 22.7988C14.2612 22.7988 14.0686 22.9914 14.0686 23.2289C14.0686 23.4665 14.2612 23.659 14.4987 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M15.9899 23.659C16.2275 23.659 16.42 23.4665 16.42 23.2289C16.42 22.9914 16.2275 22.7988 15.9899 22.7988C15.7524 22.7988 15.5598 22.9914 15.5598 23.2289C15.5598 23.4665 15.7524 23.659 15.9899 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M17.509 23.659C17.7465 23.659 17.9391 23.4665 17.9391 23.2289C17.9391 22.9914 17.7465 22.7988 17.509 22.7988C17.2714 22.7988 17.0789 22.9914 17.0789 23.2289C17.0789 23.4665 17.2714 23.659 17.509 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M19.0295 23.659C19.267 23.659 19.4596 23.4665 19.4596 23.2289C19.4596 22.9914 19.267 22.7988 19.0295 22.7988C18.7919 22.7988 18.5994 22.9914 18.5994 23.2289C18.5994 23.4665 18.7919 23.659 19.0295 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M20.5485 23.659C20.7861 23.659 20.9786 23.4665 20.9786 23.2289C20.9786 22.9914 20.7861 22.7988 20.5485 22.7988C20.311 22.7988 20.1184 22.9914 20.1184 23.2289C20.1184 23.4665 20.311 23.659 20.5485 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M22.069 23.659C22.3066 23.659 22.4991 23.4665 22.4991 23.2289C22.4991 22.9914 22.3066 22.7988 22.069 22.7988C21.8315 22.7988 21.6389 22.9914 21.6389 23.2289C21.6389 23.4665 21.8315 23.659 22.069 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M23.5602 23.659C23.7978 23.659 23.9903 23.4665 23.9903 23.2289C23.9903 22.9914 23.7978 22.7988 23.5602 22.7988C23.3227 22.7988 23.1301 22.9914 23.1301 23.2289C23.1301 23.4665 23.3227 23.659 23.5602 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M25.0793 23.659C25.3168 23.659 25.5094 23.4665 25.5094 23.2289C25.5094 22.9914 25.3168 22.7988 25.0793 22.7988C24.8417 22.7988 24.6492 22.9914 24.6492 23.2289C24.6492 23.4665 24.8417 23.659 25.0793 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M26.5983 23.659C26.8359 23.659 27.0284 23.4665 27.0284 23.2289C27.0284 22.9914 26.8359 22.7988 26.5983 22.7988C26.3608 22.7988 26.1682 22.9914 26.1682 23.2289C26.1682 23.4665 26.3608 23.659 26.5983 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M28.1188 23.659C28.3564 23.659 28.5489 23.4665 28.5489 23.2289C28.5489 22.9914 28.3564 22.7988 28.1188 22.7988C27.8813 22.7988 27.6887 22.9914 27.6887 23.2289C27.6887 23.4665 27.8813 23.659 28.1188 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M29.6379 23.659C29.8754 23.659 30.068 23.4665 30.068 23.2289C30.068 22.9914 29.8754 22.7988 29.6379 22.7988C29.4003 22.7988 29.2078 22.9914 29.2078 23.2289C29.2078 23.4665 29.4003 23.659 29.6379 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M31.1291 23.659C31.3666 23.659 31.5592 23.4665 31.5592 23.2289C31.5592 22.9914 31.3666 22.7988 31.1291 22.7988C30.8915 22.7988 30.699 22.9914 30.699 23.2289C30.699 23.4665 30.8915 23.659 31.1291 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M32.6496 23.659C32.8871 23.659 33.0797 23.4665 33.0797 23.2289C33.0797 22.9914 32.8871 22.7988 32.6496 22.7988C32.412 22.7988 32.2195 22.9914 32.2195 23.2289C32.2195 23.4665 32.412 23.659 32.6496 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M34.1686 23.659C34.4062 23.659 34.5987 23.4665 34.5987 23.2289C34.5987 22.9914 34.4062 22.7988 34.1686 22.7988C33.9311 22.7988 33.7385 22.9914 33.7385 23.2289C33.7385 23.4665 33.9311 23.659 34.1686 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M35.6891 23.659C35.9267 23.659 36.1192 23.4665 36.1192 23.2289C36.1192 22.9914 35.9267 22.7988 35.6891 22.7988C35.4516 22.7988 35.259 22.9914 35.259 23.2289C35.259 23.4665 35.4516 23.659 35.6891 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M37.1804 23.659C37.4179 23.659 37.6105 23.4665 37.6105 23.2289C37.6105 22.9914 37.4179 22.7988 37.1804 22.7988C36.9428 22.7988 36.7502 22.9914 36.7502 23.2289C36.7502 23.4665 36.9428 23.659 37.1804 23.659Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M5.40936 25.1766C5.6469 25.1766 5.83946 24.9841 5.83946 24.7465C5.83946 24.509 5.6469 24.3164 5.40936 24.3164C5.17181 24.3164 4.97925 24.509 4.97925 24.7465C4.97925 24.9841 5.17181 25.1766 5.40936 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M6.9284 25.1766C7.16594 25.1766 7.35851 24.9841 7.35851 24.7465C7.35851 24.509 7.16594 24.3164 6.9284 24.3164C6.69086 24.3164 6.49829 24.509 6.49829 24.7465C6.49829 24.9841 6.69086 25.1766 6.9284 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M8.44891 25.1766C8.68645 25.1766 8.87901 24.9841 8.87901 24.7465C8.87901 24.509 8.68645 24.3164 8.44891 24.3164C8.21136 24.3164 8.0188 24.509 8.0188 24.7465C8.0188 24.9841 8.21136 25.1766 8.44891 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M9.94012 25.1766C10.1777 25.1766 10.3702 24.9841 10.3702 24.7465C10.3702 24.509 10.1777 24.3164 9.94012 24.3164C9.70258 24.3164 9.51001 24.509 9.51001 24.7465C9.51001 24.9841 9.70258 25.1766 9.94012 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M11.4592 25.1766C11.6967 25.1766 11.8893 24.9841 11.8893 24.7465C11.8893 24.509 11.6967 24.3164 11.4592 24.3164C11.2216 24.3164 11.0291 24.509 11.0291 24.7465C11.0291 24.9841 11.2216 25.1766 11.4592 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M12.9797 25.1766C13.2172 25.1766 13.4098 24.9841 13.4098 24.7465C13.4098 24.509 13.2172 24.3164 12.9797 24.3164C12.7421 24.3164 12.5496 24.509 12.5496 24.7465C12.5496 24.9841 12.7421 25.1766 12.9797 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M14.4987 25.1766C14.7363 25.1766 14.9288 24.9841 14.9288 24.7465C14.9288 24.509 14.7363 24.3164 14.4987 24.3164C14.2612 24.3164 14.0686 24.509 14.0686 24.7465C14.0686 24.9841 14.2612 25.1766 14.4987 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M15.9899 25.1766C16.2275 25.1766 16.42 24.9841 16.42 24.7465C16.42 24.509 16.2275 24.3164 15.9899 24.3164C15.7524 24.3164 15.5598 24.509 15.5598 24.7465C15.5598 24.9841 15.7524 25.1766 15.9899 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M17.509 25.1766C17.7465 25.1766 17.9391 24.9841 17.9391 24.7465C17.9391 24.509 17.7465 24.3164 17.509 24.3164C17.2714 24.3164 17.0789 24.509 17.0789 24.7465C17.0789 24.9841 17.2714 25.1766 17.509 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M19.0295 25.1766C19.267 25.1766 19.4596 24.9841 19.4596 24.7465C19.4596 24.509 19.267 24.3164 19.0295 24.3164C18.7919 24.3164 18.5994 24.509 18.5994 24.7465C18.5994 24.9841 18.7919 25.1766 19.0295 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M20.5485 25.1766C20.7861 25.1766 20.9786 24.9841 20.9786 24.7465C20.9786 24.509 20.7861 24.3164 20.5485 24.3164C20.311 24.3164 20.1184 24.509 20.1184 24.7465C20.1184 24.9841 20.311 25.1766 20.5485 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M22.069 25.1766C22.3066 25.1766 22.4991 24.9841 22.4991 24.7465C22.4991 24.509 22.3066 24.3164 22.069 24.3164C21.8315 24.3164 21.6389 24.509 21.6389 24.7465C21.6389 24.9841 21.8315 25.1766 22.069 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M23.5602 25.1766C23.7978 25.1766 23.9903 24.9841 23.9903 24.7465C23.9903 24.509 23.7978 24.3164 23.5602 24.3164C23.3227 24.3164 23.1301 24.509 23.1301 24.7465C23.1301 24.9841 23.3227 25.1766 23.5602 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M25.0793 25.1766C25.3168 25.1766 25.5094 24.9841 25.5094 24.7465C25.5094 24.509 25.3168 24.3164 25.0793 24.3164C24.8417 24.3164 24.6492 24.509 24.6492 24.7465C24.6492 24.9841 24.8417 25.1766 25.0793 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M26.5983 25.1766C26.8359 25.1766 27.0284 24.9841 27.0284 24.7465C27.0284 24.509 26.8359 24.3164 26.5983 24.3164C26.3608 24.3164 26.1682 24.509 26.1682 24.7465C26.1682 24.9841 26.3608 25.1766 26.5983 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M28.1188 25.1766C28.3564 25.1766 28.5489 24.9841 28.5489 24.7465C28.5489 24.509 28.3564 24.3164 28.1188 24.3164C27.8813 24.3164 27.6887 24.509 27.6887 24.7465C27.6887 24.9841 27.8813 25.1766 28.1188 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M29.6379 25.1766C29.8754 25.1766 30.068 24.9841 30.068 24.7465C30.068 24.509 29.8754 24.3164 29.6379 24.3164C29.4003 24.3164 29.2078 24.509 29.2078 24.7465C29.2078 24.9841 29.4003 25.1766 29.6379 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M31.1291 25.1766C31.3666 25.1766 31.5592 24.9841 31.5592 24.7465C31.5592 24.509 31.3666 24.3164 31.1291 24.3164C30.8915 24.3164 30.699 24.509 30.699 24.7465C30.699 24.9841 30.8915 25.1766 31.1291 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M32.6496 25.1766C32.8871 25.1766 33.0797 24.9841 33.0797 24.7465C33.0797 24.509 32.8871 24.3164 32.6496 24.3164C32.412 24.3164 32.2195 24.509 32.2195 24.7465C32.2195 24.9841 32.412 25.1766 32.6496 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M34.1686 25.1766C34.4062 25.1766 34.5987 24.9841 34.5987 24.7465C34.5987 24.509 34.4062 24.3164 34.1686 24.3164C33.9311 24.3164 33.7385 24.509 33.7385 24.7465C33.7385 24.9841 33.9311 25.1766 34.1686 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M35.6891 25.1766C35.9267 25.1766 36.1192 24.9841 36.1192 24.7465C36.1192 24.509 35.9267 24.3164 35.6891 24.3164C35.4516 24.3164 35.259 24.509 35.259 24.7465C35.259 24.9841 35.4516 25.1766 35.6891 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M37.1804 25.1766C37.4179 25.1766 37.6105 24.9841 37.6105 24.7465C37.6105 24.509 37.4179 24.3164 37.1804 24.3164C36.9428 24.3164 36.7502 24.509 36.7502 24.7465C36.7502 24.9841 36.9428 25.1766 37.1804 25.1766Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M14.4987 26.7001C14.7363 26.7001 14.9288 26.5075 14.9288 26.27C14.9288 26.0324 14.7363 25.8398 14.4987 25.8398C14.2612 25.8398 14.0686 26.0324 14.0686 26.27C14.0686 26.5075 14.2612 26.7001 14.4987 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M15.9899 26.7001C16.2275 26.7001 16.42 26.5075 16.42 26.27C16.42 26.0324 16.2275 25.8398 15.9899 25.8398C15.7524 25.8398 15.5598 26.0324 15.5598 26.27C15.5598 26.5075 15.7524 26.7001 15.9899 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M17.509 26.7001C17.7465 26.7001 17.9391 26.5075 17.9391 26.27C17.9391 26.0324 17.7465 25.8398 17.509 25.8398C17.2714 25.8398 17.0789 26.0324 17.0789 26.27C17.0789 26.5075 17.2714 26.7001 17.509 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M19.0295 26.7001C19.267 26.7001 19.4596 26.5075 19.4596 26.27C19.4596 26.0324 19.267 25.8398 19.0295 25.8398C18.7919 25.8398 18.5994 26.0324 18.5994 26.27C18.5994 26.5075 18.7919 26.7001 19.0295 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M20.5485 26.7001C20.7861 26.7001 20.9786 26.5075 20.9786 26.27C20.9786 26.0324 20.7861 25.8398 20.5485 25.8398C20.311 25.8398 20.1184 26.0324 20.1184 26.27C20.1184 26.5075 20.311 26.7001 20.5485 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M22.069 26.7001C22.3066 26.7001 22.4991 26.5075 22.4991 26.27C22.4991 26.0324 22.3066 25.8398 22.069 25.8398C21.8315 25.8398 21.6389 26.0324 21.6389 26.27C21.6389 26.5075 21.8315 26.7001 22.069 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M23.5602 26.7001C23.7978 26.7001 23.9903 26.5075 23.9903 26.27C23.9903 26.0324 23.7978 25.8398 23.5602 25.8398C23.3227 25.8398 23.1301 26.0324 23.1301 26.27C23.1301 26.5075 23.3227 26.7001 23.5602 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M25.0793 26.7001C25.3168 26.7001 25.5094 26.5075 25.5094 26.27C25.5094 26.0324 25.3168 25.8398 25.0793 25.8398C24.8417 25.8398 24.6492 26.0324 24.6492 26.27C24.6492 26.5075 24.8417 26.7001 25.0793 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M26.5983 26.7001C26.8359 26.7001 27.0284 26.5075 27.0284 26.27C27.0284 26.0324 26.8359 25.8398 26.5983 25.8398C26.3608 25.8398 26.1682 26.0324 26.1682 26.27C26.1682 26.5075 26.3608 26.7001 26.5983 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M28.1188 26.7001C28.3564 26.7001 28.5489 26.5075 28.5489 26.27C28.5489 26.0324 28.3564 25.8398 28.1188 25.8398C27.8813 25.8398 27.6887 26.0324 27.6887 26.27C27.6887 26.5075 27.8813 26.7001 28.1188 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M29.6379 26.7001C29.8754 26.7001 30.068 26.5075 30.068 26.27C30.068 26.0324 29.8754 25.8398 29.6379 25.8398C29.4003 25.8398 29.2078 26.0324 29.2078 26.27C29.2078 26.5075 29.4003 26.7001 29.6379 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M31.1291 26.7001C31.3666 26.7001 31.5592 26.5075 31.5592 26.27C31.5592 26.0324 31.3666 25.8398 31.1291 25.8398C30.8915 25.8398 30.699 26.0324 30.699 26.27C30.699 26.5075 30.8915 26.7001 31.1291 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M32.6496 26.7001C32.8871 26.7001 33.0797 26.5075 33.0797 26.27C33.0797 26.0324 32.8871 25.8398 32.6496 25.8398C32.412 25.8398 32.2195 26.0324 32.2195 26.27C32.2195 26.5075 32.412 26.7001 32.6496 26.7001Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M17.509 28.2176C17.7465 28.2176 17.9391 28.0251 17.9391 27.7875C17.9391 27.55 17.7465 27.3574 17.509 27.3574C17.2714 27.3574 17.0789 27.55 17.0789 27.7875C17.0789 28.0251 17.2714 28.2176 17.509 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M19.0295 28.2176C19.267 28.2176 19.4596 28.0251 19.4596 27.7875C19.4596 27.55 19.267 27.3574 19.0295 27.3574C18.7919 27.3574 18.5994 27.55 18.5994 27.7875C18.5994 28.0251 18.7919 28.2176 19.0295 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M20.5485 28.2176C20.7861 28.2176 20.9786 28.0251 20.9786 27.7875C20.9786 27.55 20.7861 27.3574 20.5485 27.3574C20.311 27.3574 20.1184 27.55 20.1184 27.7875C20.1184 28.0251 20.311 28.2176 20.5485 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M22.069 28.2176C22.3066 28.2176 22.4991 28.0251 22.4991 27.7875C22.4991 27.55 22.3066 27.3574 22.069 27.3574C21.8315 27.3574 21.6389 27.55 21.6389 27.7875C21.6389 28.0251 21.8315 28.2176 22.069 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M23.5602 28.2176C23.7978 28.2176 23.9903 28.0251 23.9903 27.7875C23.9903 27.55 23.7978 27.3574 23.5602 27.3574C23.3227 27.3574 23.1301 27.55 23.1301 27.7875C23.1301 28.0251 23.3227 28.2176 23.5602 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M25.0793 28.2176C25.3168 28.2176 25.5094 28.0251 25.5094 27.7875C25.5094 27.55 25.3168 27.3574 25.0793 27.3574C24.8417 27.3574 24.6492 27.55 24.6492 27.7875C24.6492 28.0251 24.8417 28.2176 25.0793 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M26.5983 28.2176C26.8359 28.2176 27.0284 28.0251 27.0284 27.7875C27.0284 27.55 26.8359 27.3574 26.5983 27.3574C26.3608 27.3574 26.1682 27.55 26.1682 27.7875C26.1682 28.0251 26.3608 28.2176 26.5983 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M28.1188 28.2176C28.3564 28.2176 28.5489 28.0251 28.5489 27.7875C28.5489 27.55 28.3564 27.3574 28.1188 27.3574C27.8813 27.3574 27.6887 27.55 27.6887 27.7875C27.6887 28.0251 27.8813 28.2176 28.1188 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M29.6379 28.2176C29.8754 28.2176 30.068 28.0251 30.068 27.7875C30.068 27.55 29.8754 27.3574 29.6379 27.3574C29.4003 27.3574 29.2078 27.55 29.2078 27.7875C29.2078 28.0251 29.4003 28.2176 29.6379 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M31.1291 28.2176C31.3666 28.2176 31.5592 28.0251 31.5592 27.7875C31.5592 27.55 31.3666 27.3574 31.1291 27.3574C30.8915 27.3574 30.699 27.55 30.699 27.7875C30.699 28.0251 30.8915 28.2176 31.1291 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M32.6496 28.2176C32.8871 28.2176 33.0797 28.0251 33.0797 27.7875C33.0797 27.55 32.8871 27.3574 32.6496 27.3574C32.412 27.3574 32.2195 27.55 32.2195 27.7875C32.2195 28.0251 32.412 28.2176 32.6496 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M34.1686 28.2176C34.4062 28.2176 34.5987 28.0251 34.5987 27.7875C34.5987 27.55 34.4062 27.3574 34.1686 27.3574C33.9311 27.3574 33.7385 27.55 33.7385 27.7875C33.7385 28.0251 33.9311 28.2176 34.1686 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M35.6891 28.2176C35.9267 28.2176 36.1192 28.0251 36.1192 27.7875C36.1192 27.55 35.9267 27.3574 35.6891 27.3574C35.4516 27.3574 35.259 27.55 35.259 27.7875C35.259 28.0251 35.4516 28.2176 35.6891 28.2176Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M17.509 29.7352C17.7465 29.7352 17.9391 29.5426 17.9391 29.3051C17.9391 29.0676 17.7465 28.875 17.509 28.875C17.2714 28.875 17.0789 29.0676 17.0789 29.3051C17.0789 29.5426 17.2714 29.7352 17.509 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M19.0295 29.7352C19.267 29.7352 19.4596 29.5426 19.4596 29.3051C19.4596 29.0676 19.267 28.875 19.0295 28.875C18.7919 28.875 18.5994 29.0676 18.5994 29.3051C18.5994 29.5426 18.7919 29.7352 19.0295 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M20.5485 29.7352C20.7861 29.7352 20.9786 29.5426 20.9786 29.3051C20.9786 29.0676 20.7861 28.875 20.5485 28.875C20.311 28.875 20.1184 29.0676 20.1184 29.3051C20.1184 29.5426 20.311 29.7352 20.5485 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M22.069 29.7352C22.3066 29.7352 22.4991 29.5426 22.4991 29.3051C22.4991 29.0676 22.3066 28.875 22.069 28.875C21.8315 28.875 21.6389 29.0676 21.6389 29.3051C21.6389 29.5426 21.8315 29.7352 22.069 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M23.5602 29.7352C23.7978 29.7352 23.9903 29.5426 23.9903 29.3051C23.9903 29.0676 23.7978 28.875 23.5602 28.875C23.3227 28.875 23.1301 29.0676 23.1301 29.3051C23.1301 29.5426 23.3227 29.7352 23.5602 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M25.0793 29.7352C25.3168 29.7352 25.5094 29.5426 25.5094 29.3051C25.5094 29.0676 25.3168 28.875 25.0793 28.875C24.8417 28.875 24.6492 29.0676 24.6492 29.3051C24.6492 29.5426 24.8417 29.7352 25.0793 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M26.5983 29.7352C26.8359 29.7352 27.0284 29.5426 27.0284 29.3051C27.0284 29.0676 26.8359 28.875 26.5983 28.875C26.3608 28.875 26.1682 29.0676 26.1682 29.3051C26.1682 29.5426 26.3608 29.7352 26.5983 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M28.1188 29.7352C28.3564 29.7352 28.5489 29.5426 28.5489 29.3051C28.5489 29.0676 28.3564 28.875 28.1188 28.875C27.8813 28.875 27.6887 29.0676 27.6887 29.3051C27.6887 29.5426 27.8813 29.7352 28.1188 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M29.6379 29.7352C29.8754 29.7352 30.068 29.5426 30.068 29.3051C30.068 29.0676 29.8754 28.875 29.6379 28.875C29.4003 28.875 29.2078 29.0676 29.2078 29.3051C29.2078 29.5426 29.4003 29.7352 29.6379 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M31.1291 29.7352C31.3666 29.7352 31.5592 29.5426 31.5592 29.3051C31.5592 29.0676 31.3666 28.875 31.1291 28.875C30.8915 28.875 30.699 29.0676 30.699 29.3051C30.699 29.5426 30.8915 29.7352 31.1291 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M32.6496 29.7352C32.8871 29.7352 33.0797 29.5426 33.0797 29.3051C33.0797 29.0676 32.8871 28.875 32.6496 28.875C32.412 28.875 32.2195 29.0676 32.2195 29.3051C32.2195 29.5426 32.412 29.7352 32.6496 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M34.1686 29.7352C34.4062 29.7352 34.5987 29.5426 34.5987 29.3051C34.5987 29.0676 34.4062 28.875 34.1686 28.875C33.9311 28.875 33.7385 29.0676 33.7385 29.3051C33.7385 29.5426 33.9311 29.7352 34.1686 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M35.6891 29.7352C35.9267 29.7352 36.1192 29.5426 36.1192 29.3051C36.1192 29.0676 35.9267 28.875 35.6891 28.875C35.4516 28.875 35.259 29.0676 35.259 29.3051C35.259 29.5426 35.4516 29.7352 35.6891 29.7352Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M19.0295 31.2294C19.267 31.2294 19.4596 31.0368 19.4596 30.7992C19.4596 30.5617 19.267 30.3691 19.0295 30.3691C18.7919 30.3691 18.5994 30.5617 18.5994 30.7992C18.5994 31.0368 18.7919 31.2294 19.0295 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M20.5485 31.2294C20.7861 31.2294 20.9786 31.0368 20.9786 30.7992C20.9786 30.5617 20.7861 30.3691 20.5485 30.3691C20.311 30.3691 20.1184 30.5617 20.1184 30.7992C20.1184 31.0368 20.311 31.2294 20.5485 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M22.069 31.2294C22.3066 31.2294 22.4991 31.0368 22.4991 30.7992C22.4991 30.5617 22.3066 30.3691 22.069 30.3691C21.8315 30.3691 21.6389 30.5617 21.6389 30.7992C21.6389 31.0368 21.8315 31.2294 22.069 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M23.5602 31.2294C23.7978 31.2294 23.9903 31.0368 23.9903 30.7992C23.9903 30.5617 23.7978 30.3691 23.5602 30.3691C23.3227 30.3691 23.1301 30.5617 23.1301 30.7992C23.1301 31.0368 23.3227 31.2294 23.5602 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M26.5983 31.2294C26.8359 31.2294 27.0284 31.0368 27.0284 30.7992C27.0284 30.5617 26.8359 30.3691 26.5983 30.3691C26.3608 30.3691 26.1682 30.5617 26.1682 30.7992C26.1682 31.0368 26.3608 31.2294 26.5983 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M28.1188 31.2294C28.3564 31.2294 28.5489 31.0368 28.5489 30.7992C28.5489 30.5617 28.3564 30.3691 28.1188 30.3691C27.8813 30.3691 27.6887 30.5617 27.6887 30.7992C27.6887 31.0368 27.8813 31.2294 28.1188 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M29.6379 31.2294C29.8754 31.2294 30.068 31.0368 30.068 30.7992C30.068 30.5617 29.8754 30.3691 29.6379 30.3691C29.4003 30.3691 29.2078 30.5617 29.2078 30.7992C29.2078 31.0368 29.4003 31.2294 29.6379 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M31.1291 31.2294C31.3666 31.2294 31.5592 31.0368 31.5592 30.7992C31.5592 30.5617 31.3666 30.3691 31.1291 30.3691C30.8915 30.3691 30.699 30.5617 30.699 30.7992C30.699 31.0368 30.8915 31.2294 31.1291 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M32.6496 31.2294C32.8871 31.2294 33.0797 31.0368 33.0797 30.7992C33.0797 30.5617 32.8871 30.3691 32.6496 30.3691C32.412 30.3691 32.2195 30.5617 32.2195 30.7992C32.2195 31.0368 32.412 31.2294 32.6496 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M34.1686 31.2294C34.4062 31.2294 34.5987 31.0368 34.5987 30.7992C34.5987 30.5617 34.4062 30.3691 34.1686 30.3691C33.9311 30.3691 33.7385 30.5617 33.7385 30.7992C33.7385 31.0368 33.9311 31.2294 34.1686 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M35.6891 31.2294C35.9267 31.2294 36.1192 31.0368 36.1192 30.7992C36.1192 30.5617 35.9267 30.3691 35.6891 30.3691C35.4516 30.3691 35.259 30.5617 35.259 30.7992C35.259 31.0368 35.4516 31.2294 35.6891 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M37.1804 31.2294C37.4179 31.2294 37.6105 31.0368 37.6105 30.7992C37.6105 30.5617 37.4179 30.3691 37.1804 30.3691C36.9428 30.3691 36.7502 30.5617 36.7502 30.7992C36.7502 31.0368 36.9428 31.2294 37.1804 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M38.6994 31.2294C38.9369 31.2294 39.1295 31.0368 39.1295 30.7992C39.1295 30.5617 38.9369 30.3691 38.6994 30.3691C38.4619 30.3691 38.2693 30.5617 38.2693 30.7992C38.2693 31.0368 38.4619 31.2294 38.6994 31.2294Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M26.5983 32.7469C26.8359 32.7469 27.0284 32.5544 27.0284 32.3168C27.0284 32.0793 26.8359 31.8867 26.5983 31.8867C26.3608 31.8867 26.1682 32.0793 26.1682 32.3168C26.1682 32.5544 26.3608 32.7469 26.5983 32.7469Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M28.1188 32.7469C28.3564 32.7469 28.5489 32.5544 28.5489 32.3168C28.5489 32.0793 28.3564 31.8867 28.1188 31.8867C27.8813 31.8867 27.6887 32.0793 27.6887 32.3168C27.6887 32.5544 27.8813 32.7469 28.1188 32.7469Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M29.6379 32.7469C29.8754 32.7469 30.068 32.5544 30.068 32.3168C30.068 32.0793 29.8754 31.8867 29.6379 31.8867C29.4003 31.8867 29.2078 32.0793 29.2078 32.3168C29.2078 32.5544 29.4003 32.7469 29.6379 32.7469Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M31.1291 32.7469C31.3666 32.7469 31.5592 32.5544 31.5592 32.3168C31.5592 32.0793 31.3666 31.8867 31.1291 31.8867C30.8915 31.8867 30.699 32.0793 30.699 32.3168C30.699 32.5544 30.8915 32.7469 31.1291 32.7469Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M32.6496 32.7469C32.8871 32.7469 33.0797 32.5544 33.0797 32.3168C33.0797 32.0793 32.8871 31.8867 32.6496 31.8867C32.412 31.8867 32.2195 32.0793 32.2195 32.3168C32.2195 32.5544 32.412 32.7469 32.6496 32.7469Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M34.1686 32.7469C34.4062 32.7469 34.5987 32.5544 34.5987 32.3168C34.5987 32.0793 34.4062 31.8867 34.1686 31.8867C33.9311 31.8867 33.7385 32.0793 33.7385 32.3168C33.7385 32.5544 33.9311 32.7469 34.1686 32.7469Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M35.6891 32.7469C35.9267 32.7469 36.1192 32.5544 36.1192 32.3168C36.1192 32.0793 35.9267 31.8867 35.6891 31.8867C35.4516 31.8867 35.259 32.0793 35.259 32.3168C35.259 32.5544 35.4516 32.7469 35.6891 32.7469Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M37.1804 32.7469C37.4179 32.7469 37.6105 32.5544 37.6105 32.3168C37.6105 32.0793 37.4179 31.8867 37.1804 31.8867C36.9428 31.8867 36.7502 32.0793 36.7502 32.3168C36.7502 32.5544 36.9428 32.7469 37.1804 32.7469Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M38.6994 32.7469C38.9369 32.7469 39.1295 32.5544 39.1295 32.3168C39.1295 32.0793 38.9369 31.8867 38.6994 31.8867C38.4619 31.8867 38.2693 32.0793 38.2693 32.3168C38.2693 32.5544 38.4619 32.7469 38.6994 32.7469Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M40.2184 32.7469C40.456 32.7469 40.6485 32.5544 40.6485 32.3168C40.6485 32.0793 40.456 31.8867 40.2184 31.8867C39.9809 31.8867 39.7883 32.0793 39.7883 32.3168C39.7883 32.5544 39.9809 32.7469 40.2184 32.7469Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M26.5983 34.2704C26.8359 34.2704 27.0284 34.0778 27.0284 33.8403C27.0284 33.6027 26.8359 33.4102 26.5983 33.4102C26.3608 33.4102 26.1682 33.6027 26.1682 33.8403C26.1682 34.0778 26.3608 34.2704 26.5983 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M28.1188 34.2704C28.3564 34.2704 28.5489 34.0778 28.5489 33.8403C28.5489 33.6027 28.3564 33.4102 28.1188 33.4102C27.8813 33.4102 27.6887 33.6027 27.6887 33.8403C27.6887 34.0778 27.8813 34.2704 28.1188 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M29.6379 34.2704C29.8754 34.2704 30.068 34.0778 30.068 33.8403C30.068 33.6027 29.8754 33.4102 29.6379 33.4102C29.4003 33.4102 29.2078 33.6027 29.2078 33.8403C29.2078 34.0778 29.4003 34.2704 29.6379 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M31.1291 34.2704C31.3666 34.2704 31.5592 34.0778 31.5592 33.8403C31.5592 33.6027 31.3666 33.4102 31.1291 33.4102C30.8915 33.4102 30.699 33.6027 30.699 33.8403C30.699 34.0778 30.8915 34.2704 31.1291 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M32.6496 34.2704C32.8871 34.2704 33.0797 34.0778 33.0797 33.8403C33.0797 33.6027 32.8871 33.4102 32.6496 33.4102C32.412 33.4102 32.2195 33.6027 32.2195 33.8403C32.2195 34.0778 32.412 34.2704 32.6496 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M34.1686 34.2704C34.4062 34.2704 34.5987 34.0778 34.5987 33.8403C34.5987 33.6027 34.4062 33.4102 34.1686 33.4102C33.9311 33.4102 33.7385 33.6027 33.7385 33.8403C33.7385 34.0778 33.9311 34.2704 34.1686 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M35.6891 34.2704C35.9267 34.2704 36.1192 34.0778 36.1192 33.8403C36.1192 33.6027 35.9267 33.4102 35.6891 33.4102C35.4516 33.4102 35.259 33.6027 35.259 33.8403C35.259 34.0778 35.4516 34.2704 35.6891 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M37.1804 34.2704C37.4179 34.2704 37.6105 34.0778 37.6105 33.8403C37.6105 33.6027 37.4179 33.4102 37.1804 33.4102C36.9428 33.4102 36.7502 33.6027 36.7502 33.8403C36.7502 34.0778 36.9428 34.2704 37.1804 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M38.6994 34.2704C38.9369 34.2704 39.1295 34.0778 39.1295 33.8403C39.1295 33.6027 38.9369 33.4102 38.6994 33.4102C38.4619 33.4102 38.2693 33.6027 38.2693 33.8403C38.2693 34.0778 38.4619 34.2704 38.6994 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M40.2184 34.2704C40.456 34.2704 40.6485 34.0778 40.6485 33.8403C40.6485 33.6027 40.456 33.4102 40.2184 33.4102C39.9809 33.4102 39.7883 33.6027 39.7883 33.8403C39.7883 34.0778 39.9809 34.2704 40.2184 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M43.258 34.2704C43.4955 34.2704 43.6881 34.0778 43.6881 33.8403C43.6881 33.6027 43.4955 33.4102 43.258 33.4102C43.0204 33.4102 42.8279 33.6027 42.8279 33.8403C42.8279 34.0778 43.0204 34.2704 43.258 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M44.7492 34.2704C44.9867 34.2704 45.1793 34.0778 45.1793 33.8403C45.1793 33.6027 44.9867 33.4102 44.7492 33.4102C44.5117 33.4102 44.3191 33.6027 44.3191 33.8403C44.3191 34.0778 44.5117 34.2704 44.7492 34.2704Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M29.6379 35.7879C29.8754 35.7879 30.068 35.5954 30.068 35.3578C30.068 35.1203 29.8754 34.9277 29.6379 34.9277C29.4003 34.9277 29.2078 35.1203 29.2078 35.3578C29.2078 35.5954 29.4003 35.7879 29.6379 35.7879Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M31.1291 35.7879C31.3666 35.7879 31.5592 35.5954 31.5592 35.3578C31.5592 35.1203 31.3666 34.9277 31.1291 34.9277C30.8915 34.9277 30.699 35.1203 30.699 35.3578C30.699 35.5954 30.8915 35.7879 31.1291 35.7879Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M37.1804 35.7879C37.4179 35.7879 37.6105 35.5954 37.6105 35.3578C37.6105 35.1203 37.4179 34.9277 37.1804 34.9277C36.9428 34.9277 36.7502 35.1203 36.7502 35.3578C36.7502 35.5954 36.9428 35.7879 37.1804 35.7879Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M38.6994 35.7879C38.9369 35.7879 39.1295 35.5954 39.1295 35.3578C39.1295 35.1203 38.9369 34.9277 38.6994 34.9277C38.4619 34.9277 38.2693 35.1203 38.2693 35.3578C38.2693 35.5954 38.4619 35.7879 38.6994 35.7879Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M40.2184 35.7879C40.456 35.7879 40.6485 35.5954 40.6485 35.3578C40.6485 35.1203 40.456 34.9277 40.2184 34.9277C39.9809 34.9277 39.7883 35.1203 39.7883 35.3578C39.7883 35.5954 39.9809 35.7879 40.2184 35.7879Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M41.7389 35.7879C41.9765 35.7879 42.1691 35.5954 42.1691 35.3578C42.1691 35.1203 41.9765 34.9277 41.7389 34.9277C41.5014 34.9277 41.3088 35.1203 41.3088 35.3578C41.3088 35.5954 41.5014 35.7879 41.7389 35.7879Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M43.258 35.7879C43.4955 35.7879 43.6881 35.5954 43.6881 35.3578C43.6881 35.1203 43.4955 34.9277 43.258 34.9277C43.0204 34.9277 42.8279 35.1203 42.8279 35.3578C42.8279 35.5954 43.0204 35.7879 43.258 35.7879Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M44.7492 35.7879C44.9867 35.7879 45.1793 35.5954 45.1793 35.3578C45.1793 35.1203 44.9867 34.9277 44.7492 34.9277C44.5117 34.9277 44.3191 35.1203 44.3191 35.3578C44.3191 35.5954 44.5117 35.7879 44.7492 35.7879Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M46.2697 35.7879C46.5072 35.7879 46.6998 35.5954 46.6998 35.3578C46.6998 35.1203 46.5072 34.9277 46.2697 34.9277C46.0322 34.9277 45.8396 35.1203 45.8396 35.3578C45.8396 35.5954 46.0322 35.7879 46.2697 35.7879Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M37.1804 37.2762C37.4179 37.2762 37.6105 37.0837 37.6105 36.8461C37.6105 36.6086 37.4179 36.416 37.1804 36.416C36.9428 36.416 36.7502 36.6086 36.7502 36.8461C36.7502 37.0837 36.9428 37.2762 37.1804 37.2762Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M38.6994 37.2762C38.9369 37.2762 39.1295 37.0837 39.1295 36.8461C39.1295 36.6086 38.9369 36.416 38.6994 36.416C38.4619 36.416 38.2693 36.6086 38.2693 36.8461C38.2693 37.0837 38.4619 37.2762 38.6994 37.2762Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M40.2184 37.2762C40.456 37.2762 40.6485 37.0837 40.6485 36.8461C40.6485 36.6086 40.456 36.416 40.2184 36.416C39.9809 36.416 39.7883 36.6086 39.7883 36.8461C39.7883 37.0837 39.9809 37.2762 40.2184 37.2762Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M41.7389 37.2762C41.9765 37.2762 42.1691 37.0837 42.1691 36.8461C42.1691 36.6086 41.9765 36.416 41.7389 36.416C41.5014 36.416 41.3088 36.6086 41.3088 36.8461C41.3088 37.0837 41.5014 37.2762 41.7389 37.2762Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M43.258 37.2762C43.4955 37.2762 43.6881 37.0837 43.6881 36.8461C43.6881 36.6086 43.4955 36.416 43.258 36.416C43.0204 36.416 42.8279 36.6086 42.8279 36.8461C42.8279 37.0837 43.0204 37.2762 43.258 37.2762Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M44.7492 37.2762C44.9867 37.2762 45.1793 37.0837 45.1793 36.8461C45.1793 36.6086 44.9867 36.416 44.7492 36.416C44.5117 36.416 44.3191 36.6086 44.3191 36.8461C44.3191 37.0837 44.5117 37.2762 44.7492 37.2762Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M35.6891 38.7997C35.9267 38.7997 36.1192 38.6071 36.1192 38.3696C36.1192 38.132 35.9267 37.9395 35.6891 37.9395C35.4516 37.9395 35.259 38.132 35.259 38.3696C35.259 38.6071 35.4516 38.7997 35.6891 38.7997Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M37.1804 38.7997C37.4179 38.7997 37.6105 38.6071 37.6105 38.3696C37.6105 38.132 37.4179 37.9395 37.1804 37.9395C36.9428 37.9395 36.7502 38.132 36.7502 38.3696C36.7502 38.6071 36.9428 38.7997 37.1804 38.7997Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M38.6994 38.7997C38.9369 38.7997 39.1295 38.6071 39.1295 38.3696C39.1295 38.132 38.9369 37.9395 38.6994 37.9395C38.4619 37.9395 38.2693 38.132 38.2693 38.3696C38.2693 38.6071 38.4619 38.7997 38.6994 38.7997Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M40.2184 38.7997C40.456 38.7997 40.6485 38.6071 40.6485 38.3696C40.6485 38.132 40.456 37.9395 40.2184 37.9395C39.9809 37.9395 39.7883 38.132 39.7883 38.3696C39.7883 38.6071 39.9809 38.7997 40.2184 38.7997Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    d: "M41.7389 38.7997C41.9765 38.7997 42.1691 38.6071 42.1691 38.3696C42.1691 38.132 41.9765 37.9395 41.7389 37.9395C41.5014 37.9395 41.3088 38.132 41.3088 38.3696C41.3088 38.6071 41.5014 38.7997 41.7389 38.7997Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M43.258 38.7997C43.4955 38.7997 43.6881 38.6071 43.6881 38.3696C43.6881 38.132 43.4955 37.9395 43.258 37.9395C43.0204 37.9395 42.8279 38.132 42.8279 38.3696C42.8279 38.6071 43.0204 38.7997 43.258 38.7997Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    d: "M44.7492 38.7997C44.9867 38.7997 45.1793 38.6071 45.1793 38.3696C45.1793 38.132 44.9867 37.9395 44.7492 37.9395C44.5117 37.9395 44.3191 38.132 44.3191 38.3696C44.3191 38.6071 44.5117 38.7997 44.7492 38.7997Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M38.6994 40.3172C38.9369 40.3172 39.1295 40.1247 39.1295 39.8871C39.1295 39.6496 38.9369 39.457 38.6994 39.457C38.4619 39.457 38.2693 39.6496 38.2693 39.8871C38.2693 40.1247 38.4619 40.3172 38.6994 40.3172Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    d: "M40.2184 40.3172C40.456 40.3172 40.6485 40.1247 40.6485 39.8871C40.6485 39.6496 40.456 39.457 40.2184 39.457C39.9809 39.457 39.7883 39.6496 39.7883 39.8871C39.7883 40.1247 39.9809 40.3172 40.2184 40.3172Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M41.7389 40.3172C41.9765 40.3172 42.1691 40.1247 42.1691 39.8871C42.1691 39.6496 41.9765 39.457 41.7389 39.457C41.5014 39.457 41.3088 39.6496 41.3088 39.8871C41.3088 40.1247 41.5014 40.3172 41.7389 40.3172Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "M43.258 40.3172C43.4955 40.3172 43.6881 40.1247 43.6881 39.8871C43.6881 39.6496 43.4955 39.457 43.258 39.457C43.0204 39.457 42.8279 39.6496 42.8279 39.8871C42.8279 40.1247 43.0204 40.3172 43.258 40.3172Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M44.7492 40.3172C44.9867 40.3172 45.1793 40.1247 45.1793 39.8871C45.1793 39.6496 44.9867 39.457 44.7492 39.457C44.5117 39.457 44.3191 39.6496 44.3191 39.8871C44.3191 40.1247 44.5117 40.3172 44.7492 40.3172Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    d: "M46.2697 40.3172C46.5072 40.3172 46.6998 40.1247 46.6998 39.8871C46.6998 39.6496 46.5072 39.457 46.2697 39.457C46.0322 39.457 45.8396 39.6496 45.8396 39.8871C45.8396 40.1247 46.0322 40.3172 46.2697 40.3172Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M38.6994 41.8348C38.9369 41.8348 39.1295 41.6423 39.1295 41.4047C39.1295 41.1672 38.9369 40.9746 38.6994 40.9746C38.4619 40.9746 38.2693 41.1672 38.2693 41.4047C38.2693 41.6423 38.4619 41.8348 38.6994 41.8348Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    d: "M40.2184 41.8348C40.456 41.8348 40.6485 41.6423 40.6485 41.4047C40.6485 41.1672 40.456 40.9746 40.2184 40.9746C39.9809 40.9746 39.7883 41.1672 39.7883 41.4047C39.7883 41.6423 39.9809 41.8348 40.2184 41.8348Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M41.7389 41.8348C41.9765 41.8348 42.1691 41.6423 42.1691 41.4047C42.1691 41.1672 41.9765 40.9746 41.7389 40.9746C41.5014 40.9746 41.3088 41.1672 41.3088 41.4047C41.3088 41.6423 41.5014 41.8348 41.7389 41.8348Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    d: "M43.258 41.8348C43.4955 41.8348 43.6881 41.6423 43.6881 41.4047C43.6881 41.1672 43.4955 40.9746 43.258 40.9746C43.0204 40.9746 42.8279 41.1672 42.8279 41.4047C42.8279 41.6423 43.0204 41.8348 43.258 41.8348Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M44.7492 41.8348C44.9867 41.8348 45.1793 41.6423 45.1793 41.4047C45.1793 41.1672 44.9867 40.9746 44.7492 40.9746C44.5117 40.9746 44.3191 41.1672 44.3191 41.4047C44.3191 41.6423 44.5117 41.8348 44.7492 41.8348Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    d: "M46.2697 41.8348C46.5072 41.8348 46.6998 41.6423 46.6998 41.4047C46.6998 41.1672 46.5072 40.9746 46.2697 40.9746C46.0322 40.9746 45.8396 41.1672 45.8396 41.4047C45.8396 41.6423 46.0322 41.8348 46.2697 41.8348Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M47.7888 41.8348C48.0263 41.8348 48.2189 41.6423 48.2189 41.4047C48.2189 41.1672 48.0263 40.9746 47.7888 40.9746C47.5512 40.9746 47.3586 41.1672 47.3586 41.4047C47.3586 41.6423 47.5512 41.8348 47.7888 41.8348Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    d: "M40.2184 43.3583C40.456 43.3583 40.6485 43.1657 40.6485 42.9282C40.6485 42.6906 40.456 42.498 40.2184 42.498C39.9809 42.498 39.7883 42.6906 39.7883 42.9282C39.7883 43.1657 39.9809 43.3583 40.2184 43.3583Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M41.7389 43.3583C41.9765 43.3583 42.1691 43.1657 42.1691 42.9282C42.1691 42.6906 41.9765 42.498 41.7389 42.498C41.5014 42.498 41.3088 42.6906 41.3088 42.9282C41.3088 43.1657 41.5014 43.3583 41.7389 43.3583Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    d: "M43.258 43.3583C43.4955 43.3583 43.6881 43.1657 43.6881 42.9282C43.6881 42.6906 43.4955 42.498 43.258 42.498C43.0204 42.498 42.8279 42.6906 42.8279 42.9282C42.8279 43.1657 43.0204 43.3583 43.258 43.3583Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M44.7492 43.3583C44.9867 43.3583 45.1793 43.1657 45.1793 42.9282C45.1793 42.6906 44.9867 42.498 44.7492 42.498C44.5117 42.498 44.3191 42.6906 44.3191 42.9282C44.3191 43.1657 44.5117 43.3583 44.7492 43.3583Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    d: "M40.2184 44.8465C40.456 44.8465 40.6485 44.654 40.6485 44.4164C40.6485 44.1789 40.456 43.9863 40.2184 43.9863C39.9809 43.9863 39.7883 44.1789 39.7883 44.4164C39.7883 44.654 39.9809 44.8465 40.2184 44.8465Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M41.7389 44.8465C41.9765 44.8465 42.1691 44.654 42.1691 44.4164C42.1691 44.1789 41.9765 43.9863 41.7389 43.9863C41.5014 43.9863 41.3088 44.1789 41.3088 44.4164C41.3088 44.654 41.5014 44.8465 41.7389 44.8465Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M43.258 44.8465C43.4955 44.8465 43.6881 44.654 43.6881 44.4164C43.6881 44.1789 43.4955 43.9863 43.258 43.9863C43.0204 43.9863 42.8279 44.1789 42.8279 44.4164C42.8279 44.654 43.0204 44.8465 43.258 44.8465Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M44.7492 44.8465C44.9867 44.8465 45.1793 44.654 45.1793 44.4164C45.1793 44.1789 44.9867 43.9863 44.7492 43.9863C44.5117 43.9863 44.3191 44.1789 44.3191 44.4164C44.3191 44.654 44.5117 44.8465 44.7492 44.8465Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M46.2697 44.8465C46.5072 44.8465 46.6998 44.654 46.6998 44.4164C46.6998 44.1789 46.5072 43.9863 46.2697 43.9863C46.0322 43.9863 45.8396 44.1789 45.8396 44.4164C45.8396 44.654 46.0322 44.8465 46.2697 44.8465Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    d: "M41.7389 46.37C41.9765 46.37 42.1691 46.1774 42.1691 45.9399C42.1691 45.7023 41.9765 45.5098 41.7389 45.5098C41.5014 45.5098 41.3088 45.7023 41.3088 45.9399C41.3088 46.1774 41.5014 46.37 41.7389 46.37Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M43.258 46.37C43.4955 46.37 43.6881 46.1774 43.6881 45.9399C43.6881 45.7023 43.4955 45.5098 43.258 45.5098C43.0204 45.5098 42.8279 45.7023 42.8279 45.9399C42.8279 46.1774 43.0204 46.37 43.258 46.37Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M44.7492 46.37C44.9867 46.37 45.1793 46.1774 45.1793 45.9399C45.1793 45.7023 44.9867 45.5098 44.7492 45.5098C44.5117 45.5098 44.3191 45.7023 44.3191 45.9399C44.3191 46.1774 44.5117 46.37 44.7492 46.37Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M46.2697 46.37C46.5072 46.37 46.6998 46.1774 46.6998 45.9399C46.6998 45.7023 46.5072 45.5098 46.2697 45.5098C46.0322 45.5098 45.8396 45.7023 45.8396 45.9399C45.8396 46.1774 46.0322 46.37 46.2697 46.37Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    d: "M41.7389 47.8876C41.9765 47.8876 42.1691 47.695 42.1691 47.4575C42.1691 47.2199 41.9765 47.0273 41.7389 47.0273C41.5014 47.0273 41.3088 47.2199 41.3088 47.4575C41.3088 47.695 41.5014 47.8876 41.7389 47.8876Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M43.258 47.8876C43.4955 47.8876 43.6881 47.695 43.6881 47.4575C43.6881 47.2199 43.4955 47.0273 43.258 47.0273C43.0204 47.0273 42.8279 47.2199 42.8279 47.4575C42.8279 47.695 43.0204 47.8876 43.258 47.8876Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M44.7492 47.8876C44.9867 47.8876 45.1793 47.695 45.1793 47.4575C45.1793 47.2199 44.9867 47.0273 44.7492 47.0273C44.5117 47.0273 44.3191 47.2199 44.3191 47.4575C44.3191 47.695 44.5117 47.8876 44.7492 47.8876Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M46.2697 47.8876C46.5072 47.8876 46.6998 47.695 46.6998 47.4575C46.6998 47.2199 46.5072 47.0273 46.2697 47.0273C46.0322 47.0273 45.8396 47.2199 45.8396 47.4575C45.8396 47.695 46.0322 47.8876 46.2697 47.8876Z",
    fill: "#BB3240",
    stroke: "#BB3240",
    strokeWidth: 0.60345,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5720_93417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.333252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmenianOrganizationsSvg);
export default __webpack_public_path__ + "static/media/ArmenianOrganizationsSvg.80b55ba236054deb410c738a7dc2de7f.svg";
export { ForwardRef as ReactComponent };